// Department List for Organisation Name autocomplete
export const departmentList = [
"Cabinet Secretariat",
  "Office of the Principal Scientific Adviser",
  "Comptroller and Auditor General of India",
  "Department of Administrative Reforms & PG",
  "Agriculture Scintist Recruitment Board",
  "Agricultural Technology Application Research Institute Zone I (ICAR)",
  "Agricultural Technology Application Research Institute Zone II (ICAR)",
  "Agricultural Technology Application Research Institute Zone III (ICAR)",
  "Agricultural Technology Application Research Institute Zone IV (ICAR)",
  "Agricultural Technology Application Research Institute, Zone V (ICAR)",
  "Agricultural Technology Application Research Institute, Zone VII",
  "Agricultural Technology Application Research Institute Zone VI (ICAR)",
  "Agricultural Technology Application Research Institute, Zone VIII (ICAR)",
  "Central Agricultural University, Imphal",
  "Central Agroforestry Research Institute(ICAR)",
  "Central Arid Zone Research Institute (ICAR)",
  "Central Avian Research Institute (ICAR)",
  "Central Citrus Research Institute (ICAR)",
  "Central Coastal Agricultural Research Institute (ICAR)",
  "Central Inland Fisheries Research Institute (ICAR)",
  "Central Institue for Women in Agriculture (ICAR)",
  "Central Institute for Arid Horticulture (ICAR)",
  "Central Institute for Cotton Research (ICAR)",
  "Central Institute for Research on Buffaloes (ICAR)",
  "Central Institute for Research on Cattle (ICAR)",
  "Central Institute for Research on Cotton Technology (ICAR)",
  "Central Institute for Research on Goats (ICAR)",
  "Central Institute for Subtropical Horticulture (ICAR)",
  "Central Institute of Agricultural Engineering (ICAR)",
  "Central Institute of Brackishwater Aquaculture (ICAR)",
  "Central Institute of Fisheries Education (ICAR)",
  "Central Institute of Fisheries Technology (ICAR)",
  "Central Institute of Freshwater Aquaculture (ICAR)",
  "Central Institute of Post Harvest Engineering and Technology (ICAR)",
  "Central Institute of Temperate Horticulture (ICAR)",
  "Central Island Agricultural Research Institute (ICAR)",
  "Central Marine Fisheries Research Institute (ICAR)",
  "Central Plantation Crops Research Institute (ICAR)",
  "Central Potato Research Institute (ICAR)",
  "Central Research Institute for Dryland Agriculture (ICAR)",
  "Central Research Institute for Jute and Allied Fibre (ICAR)",
  "Central Sheep and Wool Research Institute (ICAR)",
  "Central Soil Salinity Research Institute (ICAR)",
  "Central Tobacco Research Institute (ICAR)",
  "Central Tuber Crops Research Institute (ICAR)",
  "Department of Agriculture Research & Education",
  "Directorate of Cashew Research (ICAR)",
  "Directorate of Coldwater Fisheries Research (ICAR)",
  "Directorate of Floricultural Research (ICAR)",
  "Directorate of Groundnut Research (ICAR)",
  "Directorate of Medicinal and Aromatic Plants Research (ICAR)",
  "Directorate of Mushroom Research (ICAR)",
  "Directorate of Onion and Garlic Research (ICAR)",
  "Directorate of Poultry Research (ICAR)",
  "Directorate of Rapeseed Mustard Research (ICAR)",
  "Directorate of Weed Science Research (ICAR)",
  "Directorate on Foot and Mouth Disease (ICAR)",
  "Dr. Rajendra Prasad Central Agricultural University, Samstipur",
  "ICAR Research Complex for Eastern Region (ICAR)",
  "ICAR Research Complex for NEH Region (ICAR)",
  "Indian Agricultural Research Institute (ICAR)",
  "Indian Agricultural Statistics Research Institute (ICAR)",
  "Indian Council of Agricultural Research (ICAR) Hqrs.",
  "Indian Grassland and Fodder Research Institute (ICAR)",
  "Indian Institute of Agricultural Biotechnology (ICAR)",
  "Indian Institute of Farming Systems Research (ICAR)",
  "Indian Institute of Horticultural Research (ICAR)",
  "Indian Institute of Maize Research (ICAR)",
  "Indian Institute of Millets Research (ICAR)",
  "Indian Institute of Natural Resins and Gums (ICAR)",
  "Indian Institute of Oil Palm Research (ICAR)",
  "Indian Institute of Oilseeds Research (ICAR)",
  "ndian Institute of Pulses Research (ICAR)",
  "Indian Institute of Rice Research (ICAR)",
  "Indian Institute of Seed Science (ICAR)",
  "Indian Institute of Soil Science (ICAR)",
  "Indian Institute of Soil & Water Conservation (ICAR)",
  "Indian Institute of Soybean Research (ICAR)",
  "Indian Institute of Spices Research (ICAR)",
  "Indian Institute of Sugarcane Research (ICAR)",
  "Indian Institute of Vegetable Research (ICAR)",
  "Indian Institute of Water Management (ICAR)",
  "Indian Institute of Wheat and Barley Research (ICAR)",
  "Indian Veterinary Research Institute (ICAR)",
  "National Academy of Agricultural Research Management (ICAR)",
  "National Bureau of Agricultural Insect Resources (ICAR)",
  "National Bureau of Agriculturally Important Microorganisms (ICAR)",
  "National Bureau of Animal Genetic Resources (ICAR)",
  "National Bureau of Fish Genetic Resources (ICAR)",
  "National Bureau of Plant Genetic Resources (ICAR)",
  "National Bureau of Soil Survey and Land Use Planning (ICAR)",
  "National Dairy Research Institute (ICAR)",
  "National Institute of Abiotic Stress Management (ICAR)",
  "National Institute of Agricultural Economics & Policy Research (ICAR)",
  "National Institute of Animal Nutrition and Physiology (ICAR)",
  "National Institute of Biotic Stress Management (ICAR)",
  "National Institute of High Security Animal Diseases (ICAR)",
  "National Institute of Research on Jute and Allied Fibre Technology (ICAR)",
  "National Institute of Veterinary Epidemiology and Disease Informatics (ICAR)",
  "National Research Centre for Banana (ICAR)",
  "National Research Centre for Grapes (ICAR)",
  "National Research Centre for Integrated Pest Management (ICAR)",
  "National Research Centre for Litchi (ICAR)",
  "National Research Centre for Orchids (ICAR)",
  "National Research Centre on Camel (ICAR)",
  "National Research Centre on Equines (ICAR)",
  "National Research Centre on Integrated Farming (ICAR)",
  "National Research Centre on Meat (ICAR)",
  "National Research Centre on Mithun (ICAR)",
  "National Research Centre on Pig (ICAR)",
  "National Research Centre on Plant Biotechnology (ICAR)",
  "National Research Centre on Pomegranate (ICAR)",
  "National Research Centre on Seed Spices (ICAR)",
  "National Research Centre on Yak (ICAR)",
  "National Rice Research Institute (ICAR)",
  "Rani Lakshmibai Central Agricultural University, Jhansi",
  "Sugarcane Breeding Institute (ICAR)",
  "Vivekananda Parvatiya Krishi Anusandhan Sansthan (ICAR)",
  "All India Soil & Land Use Survey",
  "Central Farm Machinery Training & Testing Institute",
  "Central Fertiliser Quality Control & Training Institute (CFQCTI), Faridabad",
  "Central Institute of Horticulture",
  "Chief Controller of Accounts, MAFW & MFAHD",
  "Coconut Development Board",
  "Commission for Agricultural Cost & Prices(CACP)",
  "Department of Agriculture, Cooperation & Farmers Welfare",
  "Directorate of Arecanut and Spices Development",
  "Directorate of Cashewnut and Cocoa Development",
  "Directorate of Cotton Development",
  "Directorate of Economics and Statistics",
  "Directorate of Extension",
  "Directorate of Jute Development",
  "Directorate of Marketing & Inspection",
  "Directorate of Millets Development",
  "Directorate of Oilseeds Development",
  "Directorate of Plant Protection Qurantine & Storage",
  "Directorate of Pulses Development",
  "Directorate of Rice Development",
  "Directorate of Sugarcane Development",
  "Directorate of Wheat Development",
  "Krishi Vigyan Kendra, Medak",
  "Krishi Vigyan Kendra, Solapur",
  "Mahalanobis National Crop Forecast Centre",
  "National Centre for Cold Chain Development",
  "National Centre of Organic Farming",
  "National Cooperative Development Corporation",
  "National Horticulture Board(NHB)",
  "National Institute of Agricultural Extension Management (MANAGE)",
  "National Institute of Agricultural Marketing(NIAM)",
  "National Institute of Plant Health Management",
  "National Rainfed Area Authority",
  "National Seeds Corporation Ltd.",
  "National Seeds Research & Training Centre (NSRTC)",
  "North Eastern Regional Farm Machinery Training & Testing Instt.",
  "Northern Region Farm Machinery Training & Testing Institute",
  "Protection of Plant Varieties and Farmers Rights Authority",
  "Small Farmers Agri Business Consortium",
  "Southern Region Farm machinery Training & Testing Institute",
  "Animal Quarantine and Certification Service, Mumbai",
  "Animal Quarantine and Certification Services,Bangalore",
  "Animal Quarantine and Certification Services,Chennai",
  "Animal Quarantine and Certification Services,Hyderabad",
  "Animal Quarantine and Certification Services,Kolkatta",
  "Animal Quarantine and Certification Services,New Delhi",
  "CCBF,Suratgarh",
  "Central Cattle Breeding Farm, Andeshnagar",
  "Central Cattle Breeding Farm, Chennai",
  "Central Cattle Breeding Farm, Chiplima",
  "Central Cattle Breeding Farm, Dhamrod",
  "Central Cattle Breeding Farm,Hesserghatta",
  "Central Cattle Breeding Farm, Sunebeda",
  "Central Frozen Semen Production & Training Instt., Hesserghatta",
  "Central Herd Registration Scheme, Ahmedabad",
  "Central Herd Registration Scheme, Ajmer",
  "Central Herd Registration Scheme, Ongole",
  "Central Herd Registration Scheme, Rohtak",
  "Central Institute of Coastal Engineering For Fishery (CICEF),Banglore",
  "Central Poultry Devlopment Organization(ER),Bhubneshwar",
  "Central Poultry Devlopment Organization,Hessarghatta",
  "Central Poultry Devlopment Organization(NR),Chandigarh",
  "Central Poultry Devlopment Organization(NR),Chandigarh",
  "Central Poultry Performing Testing Centre, Gurgoan",
  "Central Sheep Breeding Farm,Hissar",
  "CIFNET, Kochi",
  "CIFNET, Royapuram, Chennai",
  "CIFNET, Vishakhapatnam",
  "Delhi Milk Scheme, New Delhi",
  "Department of Animal Husbandry, Dairying and Fisheries",
  "Department of Fisheries",
  "Fisheries Survey of India, Mumbai Base",
  "Fisheries Survey of India, Porbandar Base",
  "Fishery Survey of India, Bogda (Mormugao)",
  "Fishery Survey of India, Chennai",
  "Fishery Survey of India,Kochi",
  "Fishery Survey of India, Mumbai",
  "Fishery Survey of India, Portblair",
  "Fishery Survey of India, Vishakhapatnam",
  "National Dairy Development Board",
  "National Fisheries Development Board, Hyderabad",
  "National Institute of Animal Health (NIAH),Baghpat",
  "National Institute of Fisheries Post Harvest Technology and Training (NIFPHATT), Kochi",
  "NIFPHATT, Vishakhapatnam",
  "Reginal Fodder Station, Hyderabad",
  "Reginal Fodder Station, Jammu",
  "Reginal Fodder Station, Kalyani",
  "Regional Fodder Station, Chennai",
  "Regional Fodder Station, Hissar",
  "Veterinary Council of India",
  "Atomic Energy Education Society",
  "Atomic Energy Regulatory Board",
  "Atomic Minerals Directorate for Exploration & Research",
  "BARC Facilities, Kalpakkam",
  "Bhabha Atomic Resarch Centre (Tarapur)",
  "Bhabha Atomic Research Centre",
  "Bhabha Atomic Research Centre (Vizag)",
  "Bharatiya Nabhikiya Vidhyut Nigam Ltd. (BHAVINI)",
  "Board of Radiation and Isotope Technology",
  "Department of Atomic Energy",
  "Directorate of Construction, Services & Estate Management",
  "Directorate of Purchase and Stores",
  "Electronics Corporation of India Ltd.",
  "General Services Organisation, Kalpakkam",
  "Global Centre for Nuclear Energy Partnership",
  "Harish Chandra Research Institute",
  "Heavy Water Board (CO), HWP (Thal) and HWP (Hazira)",
  "Heavy Water Plant(Baroda)",
  "Heavy Water Plant (Kota)",
  "Heavy Water Plant (Manuguru)",
  "Heavy Water Plant (Talcher)",
  "Heavy Water Plant (Tuticorin)",
  "Homi Bhabha National Institute",
  "Indian Rare Earths Limited",
  "Indira Gandhi Centre for Atomic Research",
  "Institute for Plasma Research",
  "Institute of Mathematical Sciences,",
  "Institute of Physics (IOP)",
  "National Centre for Radio Astrophysics, Pune",
  "National Institute of Science Education and Research Centre",
  "Nuclear Fuel Complex",
  "Nuclear Power Corporation of India Limited",
  "Nuclear Recycle Board, Mumbai",
  "Raja Ramanna Centre for Advanced Technology",
  "Rare Materials Project (Mysore)",
  "Saha Institute of Nuclear Physics",
  "Tata Institute of Fundamental Research",
  "Tata Memorial Centre",
  "UM-DAE Centre for Excellence in Basic Sciences",
  "Uranium Corporation of India Limited",
  "Variable Energy Cyclotron Centre",
  "Bharat Immunolgicals & Biologicals Corp. Ltd.(BIBCOL)",
  "Biotechnology Industry Research Assistance Council (BIRAC)",
  "Center of Innovative and Applied Bioprocessing, Mohali",
  "Centre for DNA Fingerprinting and Diagnostics(CDFD)",
  "Department of Bio-Technology",
  "Indian Vaccines Corporation Limited (IVCOL)",
  "Institute of Bioresources & Sustainable Development(IBSD)",
  "Institute of Life Sciences(ILS)",
  "Institute of Stem Cell Science and Regenerative Medicine (inStem)",
  "National Agri Food Biotechnology Institute (NABI)",
  "National Brain Research Centre(NBRC)",
  "National Centre for Cell Science(NCCS)",
  "National Institute of Animal Biotechnolgy(NIAB)",
  "National Institute of Biomedical Genomics",
  "National Institute of Immunology (NII)",
  "National Institute of Plant Genome Researchc (NIPGR)",
  "Rajiv Gandhi Centre for Biotechnology",
  "Regional Centre for Biotechnology",
  "Translational Health Science and Technology Institute",
  "Brahmaputra Cracker and Polymer Limited",
  "Central Insititute of Plastics Engineering and Technology (CIPET)",
  "Department of Chemicals & Petrochemicals",
  "Hindustan Fluorocarbons Limited",
  "Hindustan Insecticides Limited",
  "Hindustan Organic Chemical Ltd",
  "Institute of Pesticide Formulation Technology",
  "Office of the Welfare Commissioner Bhopal Gas",
  "Agricultural and Processed Food Products Export Development Authority",
  "Cochin Special Economic Zone",
  "Coffee Board",
  "Department of Commerce",
  "Directorate General of Foreign Trade",
  "Directorate General of Trade Remedies (DGTR)",
  "ECGC LIMITED",
  "Export Inspection Council of India",
  "Falta Special Economic Zone",
  "Footwear Design and Development Insitute",
  "Government e marketplace",
  "Hindustan Diamond Company Pvt. Ltd.",
  "Indian Institute of Foreign Trade",
  "INDIAN INSTITUTE OF FOREIGN TRADE",
  "Indian Institute of Packaging",
  "India Trade Promotion Organisation",
  "Kandla Special Economic Zone",
  "MEPZ Special Economic Zone & HEOUs",
  "MMTC Limited",
  "National Centre For Trade Information ( NCTI )",
  "Noida Special Economic Zone",
  "PEC Ltd.",
  "Rubber Board",
  "SEEPZ Special Economic Zone",
  "Spices Board India",
  "STCL Limited",
  "Tea Board",
  "Tea Research Association",
  "The Marine Products Export Development Authority",
  "The State Trading Corporation of India Ltd.",
  "Tobacco Board",
  "UPASI Tea Research Foundation",
  "Vishakhapatnam Special Economic Zone",
  "Bureau of Indian Standards(HQs)",
  "Central Consumer Protection Authority(CCPA)",
  "Department of Consumer Affairs",
  "Indian Institute of Legal Metrology",
  "National Consumer Disputes Redressal Commission",
  "National Test House",
  "Regional Reference Standard Laboratory, Ahmedabad",
  "Regional Reference Standard Laboratory, Bangalore",
  "Regional Reference Standard Laboratory, Faridabad",
  "Regional Reference Standard Laboratory, Guwahati",
  "Regional Reference Standards Laboratory,Bhubaneswar",
  "Regional Reference Standards Laboratory, Guwahati",
  "ADEO, Agartala",
  "ADEO, Baramulla",
  "ADEO, Port Blair",
  "ADEO, Rajouri",
  "Armed Forces Films & Photo Division",
  "Border Road Organisation",
  "Border Roads Development Board (BRDB)",
  "CB, Agra",
  "CB, Ahmedabad",
  "CB, Ahmednagar",
  "CB, Ajmer",
  "CB, Allahabad",
  "CB, Almora",
  "CB Ambala",
  "CB, Amritsar",
  "CB,Aurangabad",
  "CB, Babina",
  "CB, Badamibagh",
  "CB, Bakloh",
  "CB, Bareily",
  "CB, Barrackpore",
  "CB, Belgaum",
  "CB, Cannanore",
  "CB, Chakrata",
  "CB, Clementtown",
  "CB, Dagshai",
  "CB, Dalhousie",
  "CB, Danapur",
  "CB, Dehradun",
  "CB, Dehuroad",
  "CB , Delhi",
  "CB,Deolali",
  "CB, Faizabad",
  "CB, Fatehgar",
  "CB, Ferozpur",
  "CB, Jabalpur",
  "CB, Jalandhar",
  "CB, Jalapahar",
  "CB, Jammu",
  "CB, Jhansi",
  "CB, Jutogh",
  "CB, Kamptee",
  "CB, Kanpur",
  "CB, Kasauli",
  "CB, Khasyol",
  "CB, Kirkee",
  "CB, Landour",
  "CB, Lansdowne",
  "CB, Lebong",
  "CB, Lucknow",
  "CB, Mathura",
  "CB, Meerut",
  "CB, Mhow",
  "CB, Morar",
  "CB, Nainital",
  "CB, Nasirabad",
  "CB, Pachmarhi",
  "CB, Pune",
  "CB, Ramgarh",
  "CB, Ranikhet",
  "CB, Roorkee",
  "CB, Saugor",
  "CB, Secundrabad",
  "CB, Shahjahanpur",
  "CB Shillong",
  "CB, St. Thomas Mount",
  "CB, Subathu",
  "CB, Varanasi",
  "CB, Wellington",
  "Central Organisation ECHS",
  "College of Defence Management",
  "Controller General of Defence Accounts (CGDA)",
  "Defence Services Staff College",
  "Department of Defence",
  "DEO, Agra",
  "DEO, Ahmedabad",
  "DEO, Allahabad",
  "DEO, Ambala",
  "DEO, Bangalore",
  "DEO Bareily",
  "DEO Bathinda",
  "DEO, Bhopal",
  "DEO, Bhubaneshwar",
  "DEO Bikaner",
  "DEO, Chandigarh",
  "DEO, Chennai",
  "DEO, Cochin",
  "DEO,Danapur",
  "DEO, Delhi",
  "DEO, Goa",
  "DEO, Guwahati",
  "DEO, Jabalpur",
  "DEO Jaipur",
  "DEO Jalandhar",
  "DEO, Jammu",
  "DEO, Jodhpur",
  "DEO, Jorhat",
  "DEO, Kolkata",
  "DEO, Leh",
  "DEO , Lucknow",
  "DEO, Meerut",
  "DEO, MHOW",
  "DEO, Mumbai",
  "DEO Pathankot",
  "DEO, Pune",
  "DEO, Secunderabad",
  "DEO, Siliguri",
  "DEO, Srinagar",
  "DEO, Tezpur",
  "DEO, Udhampur",
  "DEO, Vizag",
  "Department of Military Affairs",
  "Directorate General, Armed Forces Medical Services",
  "Directorate General Defence Estates (DGDE)",
  "Directorate General Resettlement (DGR)",
  "Directorate of Public Relations",
  "Director General National Cadet Corps (NCC)",
  "Himalayan Mountaineering Institute (HMI)",
  "History Division",
  "Indian Coast Guard",
  "Institute for Defence Studies and Analyses",
  "Jawahar Institute of Mountaineering & Winter Sports (JIM)",
  "Kendriya Sainik Board",
  "Metal and Steel Factory, Ishapore",
  "Military Engineer Services",
  "National Defence College",
  "National Institute of Mountaineering and Allied Sports (NIMAS)",
  "Nehru Institute of Mountaineering (NIM)",
  "Office of Chief Administrative Officer (CAO)",
  "PDDE,CC, Lucknow",
  "PDDE, EC, Kolkata",
  "PDDE,NC, Jammu",
  "PDDE, SC, Pune",
  "PDDE , SWC, Jaipur",
  "PDDE,WC, Chandigarh",
  "School of Foreign Languages",
  "Security Office",
  "Services Sports Control Board (SSCB)",
  "Weapons and Electronics Systems Engineering Establishment",
  "BEML Limited",
  "Bharat Dynamics Ltd.",
  "Bharat Electronics Ltd.",
  "Department of Defence Production",
  "Defence Exhibition Organisation",
  "Directorate General of Aeronautical Quality Assurance",
  "Directorate General of Quality Assurance",
  "Directorate of Planning and Coordination",
  "Directorate of Standardisation",
  "Garden Reach Shipbuilders and Engineers Limited",
  "Goa Shipyard Limited",
  "Heavy Vehicle Factory, Avadi",
  "Hindustan Aeronautics Ltd.",
  "Hindustan Shipyard Limited (HSL)",
  "Mazagon Dock Limited",
  "MIDHANI Limited",
  "National Academy of Defence Production",
  "Ordnance Factory Board",
  "Regional Collecterate of Safety (Western Region)",
  "Ordnance Factory Dum Dum",
  "Department of Economic Affairs",
  "India Security Press, Nashik Road",
  "National Savings Institute (NSI)",
  "Securities and Exchange Board of India (SEBI), Head Office",
  "Securities Appellate Tribunal (SAT)",
  "Specified Undertaking of Unit Trust of India (SUUTI), Mumbai",
  "SPMCIL - Bank Note Press",
  "SPMCIL Corporate Office",
  "SPMCIL Currency Note Press Nashik",
  "SPMCIL India Government Mint, Hyderabad",
  "SPMCIL - India Government Mint, Kolkata",
  "SPMCIL - India Government Mint, Mumbai",
  "SPMCIL - India Government Mint, Noida",
  "SPMCIL Security Paper Mill, Hoshangabad",
  "SPMCIL - Security Printing Press, Hyderabad",
  "UTI Infrastructure Technolgoy And Services Limited",
  "Centre for Development of Advanced Computing (CDAC)",
  "Centre for Materials for Electronics Technology (C-MET)",
  "Controller of Certifying Authorities (CCA)",
  "Cyber Appellate Tribunal (CAT)",
  "Department of Electronics & Information Technology",
  "Digital India Corporation",
  "ERNET India",
  "National Informatics Centre",
  "National Informatics Centre Services Incorporated (NICSI)",
  "National Institute of Electronics & Information Technology",
  "National Internet Exchange of India (NIXI)",
  "Semi Conductor Laboratory, Chandigarh",
  "Society for Applied Microwave Electronics Engineering and Research (SAMEER)",
  "Software Technology Parks of India (STPI)",
  "Standardization, Testing and Quality Certification (STQC)",
  "Department of Empowerment of Person with Disabilities (Divyangjan)",
  "Central Pension Accounting Office",
  "Controller General of Accounts",
  "Department of Expenditure",
  "Department of Ex-Servicemen Welfare",
  "Brahmaputra Valley Fertilizer Corporation Ltd. (BVFCL)",
  "Department of Fertilisers",
  "FCI Aravali Gypsum and Minerals India Limited (FAGMIL)",
  "Fertilizer and Chemical Travencore Limited (FACT)",
  "Fertilizer Corporation of India Limited (FCI)",
  "Hindustan Fertilizers Corporation Limited (HFC)",
  "Madras Fertilizer Limited (MFL)",
  "National Fertilizer Limited (NFL)",
  "Projects & Development of India Ltd. (PDIL)",
  "Rashtriya Chemicals and Fertilizers Ltd. (RCF)",
  "Agriculture Insurance Company of India Ltd.",
  "Andhra Pradesh Grameena Vikas Bank",
  "Andhra Pragathi Grameena Bank",
  "Arunachal Pradesh Rural Bank",
  "Aryavart Bank",
  "Assam Gramin Vikash Bank",
  "Bangiya Gramin Vikash Bank",
  "Bank of Baroda",
  "Bank of India",
  "Bank of Maharashtra",
  "Baroda Gujarat Gramin Bank",
  "Baroda Rajasthan Kshetriya Gramin Bank",
  "Baroda U.P Bank",
  "Canara Bank",
  "Central Bank of India",
  "Central Registry of Securitisation Asset Reconstruction and Security Interest of India (CERSAI)",
  "Chaitanya Godavari Grameena Bank",
  "Chhattisgarh Rajya Gramin Bank",
  "Dakshin Bihar Gramin Bank, Patna",
  "Debts Recovery Appellate Tribunal,Kolkata",
  "Debts Recovery Tribunal No.2 Kolkata",
  "Department of Financial Services",
  "DRAT, Allahabad",
  "DRAT, Chennai",
  "DRAT, Delhi",
  "DRAT, MUMBAI",
  "DRT-2,Ernakulam",
  "DRT, Allahabad",
  "DRT, Aurangabad",
  "DRT, Bangalore",
  "DRT, Chandigarh",
  "DRT, Coimbatore",
  "DRT Cuttack",
  "DRT, Ernakulam",
  "DRT, Guwahati",
  "DRT, Hyderabad",
  "DRT I, Chennai",
  "DRT- I, Delhi",
  "DRT-II, Chandigarh",
  "DRT-II Chennai",
  "DRT-II Delhi",
  "DRT-III, Chandigarh",
  "DRT-III, Chennai",
  "DRT-III, Delhi",
  "DRT III Kolkata",
  "DRT III Mumbai",
  "DRT II Mumbai",
  "DRT I, Kolkata",
  "DRT Il, Ahmedabad",
  "DRT-Jabalpur",
  "DRT, Jaipur",
  "DRT l, Ahmedabad",
  "DRT, Lucknow",
  "DRT, Madurai",
  "DRT, Mumbai-I",
  "DRT, Nagpur",
  "DRT, Patna",
  "DRT, Pune",
  "DRT, Ranchi",
  "DRT, Vishakhapatnam",
  "Ellaquai Dehati Bank",
  "Executive Council Of Insurers",
  "Export Import Bank of India (EXIM Bank)",
  "Financial Services Institutions Bureau (FSIB)",
  "Financial Services Institutions Bureau (FSIB)",
  "General Insurance Corporation of India",
  "Himachal Pradesh Gramin Bank, Mandi",
  "IDBI Bank Ltd.",
  "IFCI Ltd",
  "India Infrastructure Finance Co. Ltd. (IIFCL)",
  "Indian Bank",
  "Indian Overseas Bank",
  "Insurance Regulatory and Development Authority of India",
  "Jharkhand Rajya Gramin Bank",
  "J&K Grameen Bank",
  "J&K Grameen Bank",
  "Karnataka Vikas Grameena Bank",
  "Kerala Gramin Bank",
  "LIC Central Office: Mumbai",
  "LIC CZ: Chhattisgarh, M.P",
  "LIC ECZ: Bihar, Jharkhand, Odisha",
  "LIC EZ: Arunachal, Assam, Manipur, Meghalaya, Mizoram, Nagaland, Sikkim, Tripura, W.B",
  "LIC NCZ: U.P., Uttrakhand",
  "LIC NZ: Delhi, H.P., Haryana, J&K, Punjab, Rajasthan",
  "LIC SCZ: Andhra, Karnataka, Telangana",
  "LIC SZ: Kerala, Tamil Nadu",
  "LIC WZ: Goa, Gujarat, Maharashtra",
  "Madhyanchal Gramin Bank",
  "Madhya Pradesh Gramin Bank",
  "Maharashtra Gramin Bank",
  "Manipur Rural Bank",
  "Meghalaya Rural Bank",
  "Mizoram Rural Bank",
  "NABARD",
  "Nagaland Rural Bank",
  "National Housing Bank (NHB)",
  "National Insurance Company Limited",
  "National Pension System Trust",
  "Odisha Gramya Bank",
  "Office of the Custodian",
  "Office of the Insurance Ombudsman, Ahmedabad",
  "Office of the Insurance Ombudsman, Bengaluru",
  "Office of the Insurance Ombudsman, Bhopal",
  "Office of the Insurance Ombudsman, Bhubaneswar",
  "Office of the Insurance Ombudsman, Chandigarh",
  "Office of the Insurance Ombudsman, Chennai",
  "Office of the Insurance Ombudsman, Delhi",
  "Office of the Insurance Ombudsman, Guwahati",
  "Office of the Insurance Ombudsman, Hyderabad",
  "Office of the Insurance Ombudsman, Jaipur",
  "Office of the Insurance Ombudsman, Kochi",
  "Office of the Insurance Ombudsman, Kolkata",
  "Office of the Insurance Ombudsman, Lucknow",
  "Office of the Insurance Ombudsman, Mumbai",
  "Office of the Insurance Ombudsman, Noida",
  "Office of the Insurance Ombudsman, Patna",
  "Office of the Insurance Ombudsman, Pune",
  "Oriental Insurance Company Ltd.",
  "Paschim Banga Gramin Bank",
  "Pension Fund Regulatory and Development Authority",
  "Prathama U P Gramin Bank, Moradabad",
  "Puduvai Bharathiar Grama Bank",
  "Punjab Gramin Bank, Kapurthala",
  "Punjab National Bank",
  "Punjab & Sind Bank",
  "Rajasthan Marudhara Gramin Bank",
  "Reserve Bank of India",
  "Sarva Haryana Gramin Bank, Rohtak",
  "Saurashtra Gramin Bank",
  "SBI Ahmedabad Circle",
  "SBI Amravati Circle",
  "SBI Bangalore Circle",
  "SBI Bhopal Circle",
  "SBI Bhubaneswar Circle",
  "SBI Chandigarh Circle",
  "SBI Chennai Circle",
  "SBI - Corporate Centre",
  "SBI Delhi Circle",
  "SBI Guwahati Circle",
  "SBI Hyderabad Circle",
  "SBI Jaipur Circle",
  "SBI Kolkata Circle",
  "SBI Lucknow Circle",
  "SBI Maharashtra Circle",
  "SBI Mumbai Metro Circle",
  "SBI Patna Circle",
  "SBI Trivandrum Circle",
  "Small Industries Development Bank of India (SIDBI)",
  "Stresssed Assets Stabilization Fund (SASF)",
  "Syndicate Bank Regional Office-Puttur",
  "TAMIL NADU GRAMA BANK",
  "Telangana Grameena Bank",
  "The New India Assurance Company Ltd.",
  "Tripura Gramin Bank",
  "UCO Bank",
  "Union Bank of India",
  "United Bank of India",
  "United India Insurance Co. Ltd.",
  "Utkal Grameen Bank",
  "Uttarakhand Gramin Bank",
  "Uttar Banga Kshetriya Gramin Bank",
  "Uttar Bihar Gramin Bank",
  "Vidharbha Konkan Gramin Bank",
  "SAPTAGIRI GRAMEENA BANK",
  "Central Railside Warehouse Company Limited",
  "Central Warehousing Corporation",
  "Department of Food & Public Distribution",
  "Directorate of Sugar & Vegetable Oils",
  "Directorate of Vananspati, Vegetable Oils & Fats",
  "Food Corporation of India",
  "Hindustan Vegetable Oils Corporation",
  "Hindustan Vegetable Oils Corporation",
  "Indian Grain Storage Management & Research Institute, Field Station, Hyderabad",
  "Indian Grain Storage Management & Research Institute, Field Station, Ludhiana",
  "Indian Grain Storage Management & Research Institute, Hapur",
  "National Sugar Institute, Kanpur",
  "Quality Control Cell, Bangalore",
  "Quality Control Cell, Bhopal",
  "Quality Control Cell, Bhubaneswar",
  "Quality Control Cell, Hyderabad",
  "Quality Control Cell, Kolkata",
  "Quality Control Cell, Lucknow",
  "Quality Control Cell, Pune",
  "AIIMS, Bhopal",
  "AIIMS, Bhubaneshwar",
  "AIIMS, Jodhpur",
  "AIIMS, Patna",
  "AIIMS, Raipur",
  "AIIMS, Rishikesh",
  "All India Institute of Hygiene and Public Health",
  "All India Institute of Medical Sciences (AIIMS), Delhi",
  "All INDIA INSTITUTE OF PHYSICAL MEDICINE AND REHABLITATION, MUMBAI",
  "All India Institute of Speech and Hearing",
  "BCG VACCINE LABORATORY",
  "Bhopal Memorial Hospital & Research Centre (BMHRC)",
  "Central Council for Research in Ayurvedic Sciences (CCRAS)",
  "Central Council for Research in Homoeopathy",
  "Central Council for Research in Yoga & Naturopathy",
  "CENTRAL DRUGS STANDARD CONTROL ORGANISATION",
  "Central Government Health Scheme",
  "CENTRAL INSTITUTE OF PSYCHIATRY,RANCHI",
  "Central Medical Services Society",
  "Central Research Instirute.Kasauli",
  "CGHS Ahemdabad",
  "CGHS Chandigarh",
  "CGHS, Delhi",
  "CGHS Guwahati",
  "CGHS Jabalpur",
  "CGHS, Jaipur",
  "CGHS Meerut",
  "CGHS patna",
  "CGHS, Shillong",
  "Chintranjan National Cancer Institute.",
  "Dental Council of India",
  "Department of Health & Family Welfare",
  "Directorate General of Health Services",
  "DR. R. M. L. HOSPITAL, NEW DELHI",
  "HLL BioTech Limited",
  "HLL Lifecare Limited",
  "HSCC, India Ltd.",
  "ICMR-National Institute of Cholera and Enteric Diseases (NICED)",
  "Indian Council of Medical Research",
  "Indian Nursing Council",
  "INDIAN PHARMACOPOEIA COMMISSION, GHAZIABAD",
  "International Institute of Population Sciences",
  "JAWAHARLAL INSTITUTE OF POST GRADUATE MEDICAL EDUCATION AND RESEARCH, PONDICHERRY",
  "KALAWATI SARAN CHILDRENS HOSPITAL, NEW DELHI",
  "LHMC AND SMT. S.K. HOSPITAL, NEW DELHI.",
  "Medical Stores Organisation",
  "Morarji Desai National Institute of Yoga",
  "National Academy of Medical Sciences",
  "National AIDS Control Organization (NACO)",
  "National AIDS Research Institute, Pune",
  "National Board of Examinations in Medical Sciences",
  "NATIONAL CENTRE FOR DISEASE CONTROL, DELHI",
  "National Commission for Indian System of Medicine (NCISM)",
  "National Health Authority",
  "National Institute of Biologicals",
  "National Institute of Health & Family Welfare",
  "National Institute of Mental Health & Neuro Sciences (NIMHANS)",
  "National Institute of Tuberculosis and Respiratory Diseases",
  "National Medical Commission",
  "NATIONAL VECTOR BORNE DISEASE CONTROL PROGRAMME, NEW DELHI",
  "North Eastern Indira Gandhi Regional Institute of Health & Medical Sciences.",
  "Pasteur Institute of India",
  "PG Institute of Medical Education & Research, Chandigarh",
  "Pharmacy Council of India",
  "Pr. Accounts Office, M/o Health & Family Welfare",
  "Regional Institute of Medical Sciences,Imphal",
  "Rural Health Training Centre, Najafgarh",
  "SAFDARJUNG HOSPITAL,NEW DELHI",
  "Department of Health Research",
  "ICMR-National AIDS Research Institute (NARI), Pune",
  "ICMR-National Animal Resource Facility for Biomedical Research (NARFBR), Hyderabad",
  "ICMR-National Centre for Disease Informatics and Research (NCDIR), Bengaluru",
  "ICMR-National Institue for Research in Environmental Health (NIREH), Bhopal",
  "ICMR-National Institue of Occupational Health (NIOH), Ahmedabad",
  "ICMR-National Institute for Implementation Research on Non Communicable Diseases (NIIRNCD), Jodhpur",
  "ICMR-National Institute for Research in Reproductive Health (NIRRH), Mumbai",
  "ICMR-NATIONAL INSTITUTE FOR RESEARCH IN TUBERCULOSIS",
  "ICMR-National Institute of Cancer Prevention and Research (NICPR), Noida",
  "ICMR-National Institute of Epidemiology (NIE), Chennai",
  "ICMR-National Institute of Immunohaematology (NIIH), Mumbai",
  "ICMR-National Institute of Malaria Research (NIMR), New Delhi",
  "ICMR-National Institute of Medical Statistics (NIMS), New Delhi",
  "ICMR-National Institute of Nutrition (NIN), Hyderabad",
  "ICMR-National Institute of Pathology (NIOP), New Delhi",
  "ICMR-National Institute of Research in Tribal Health",
  "ICMR-National Institute of Traditional Medicine (NITM), Belagavi",
  "ICMR-National Institute of Virology (NIV), Pune",
  "ICMR-National JALMA Institute for Leprosy & Other Mycrobacterial Diseases (NJIL & OMD), Agra",
  "ICMR-Rajendra Memorial Research Institute of Medical Sciences (RMRIMS), Patna",
  "ICMR-Regional Medical Research Centre (RMRC), Bhubaneswar",
  "ICMR-Regional Medical Research Centre (RMRC), Gorakhpur",
  "ICMR-Regional Medical Research Centre (RMRC), N. E. Region, Dibrugarh",
  "ICMR-Regional Medical Research Centre (RMRC), Port Blair",
  "ICMR-Vector Control Research Centre (VCRC), Puducherry",
  "Andrew Yule & Company Limited",
  "Automotive Research Association of India (ARAI)",
  "BBJ Construction Co. Ltd.",
  "Bharat Heavy Electricals (BHEL)",
  "Bharat Pumps and Compressors Ltd.",
  "BHEL Electric Machines Limited",
  "Bridge and Roof Co India Ltd",
  "Cement Corporation of India Ltd.",
  "Department of Heavy Industries",
  "Engineering Projects (India) Ltd.",
  "Fluid Control Research Institute",
  "Heavy Engineering Corporation Ltd.",
  "Hindustan Cables Ltd.",
  "Hindustan Newsprint Ltd.",
  "Hindustan Paper Corporation Ltd.",
  "Hindustan Salts Ltd.",
  "HMT (International ) Ltd.",
  "HMT Ltd.",
  "HMT Machine Tools Ltd.",
  "Hooghly Printing Co. Ltd.",
  "Nagaland Pulp & Paper Co Ltd",
  "National Automotive Training and R&D Infrastructure Project",
  "NEPA Ltd.",
  "Rajasthan Electronics & Instruments Ltd.",
  "Richardson Cruddas Ltd.",
  "Sambhar Salts Ltd",
  "Scooters India Ltd.",
  "Aligarh Muslim University",
  "All India Council for Technical Education (AICTE)",
  "Assam University",
  "Association of Indian Universities (AIU)",
  "Auroville Foundation",
  "Babasaheb Bhimrao Ambedkar University",
  "Banaras Hindu University",
  "Board of Apprenticeship Training (BOAT) (NR) Kanpur",
  "Board of Apprenticeship Training, Chennai",
  "Board of Apprenticeship Training (W R) Mumbai",
  "Board of Practical Training Eastern Region Kolkata",
  "Central Hindi Directorate",
  "CENTRAL INSTITUTE OF CLASSICAL TAMIL (CICT)",
  "Central Institute of Indian Languages (CIIL)",
  "Central Institute of Technology, Kokrajhar",
  "Central University of Gujarat",
  "CENTRAL UNIVERSITY OF HARYANA",
  "Central University of Himachal Pradesh",
  "Central University of Jammu",
  "Central University of Jharkhand",
  "CENTRAL UNIVERSITY OF KARNATAKA",
  "Central University of Kashmir",
  "Central University of Kerala",
  "Central University of Orissa",
  "Central University of Punjab",
  "Central University of Rajasthan",
  "CENTRAL UNIVERSITY OF SOUTH BIHAR",
  "Central University of Tamil Nadu",
  "Commission for Scientific and Technical Terminology (CSTT)",
  "Council of Architecture",
  "Department of Higher Education",
  "Dr. B.R. Ambedkar National Institute of Technology, Jallandhar",
  "Dr. Harisingh Gour University",
  "EdCIL (India) Limited",
  "Ghani Khan Choudhury Institute of Engineering and Technology (GKCIET)",
  "Guru Ghasidas Vishvidyalaya, Bilaspur",
  "Hemvati Nandan Bahuguna Garhwal University",
  "IIIT, Nagpur",
  "IIIT Senapati",
  "IIIT Tiruchirappalli",
  "IIT-Banaras Hindu University(BHU)",
  "Indian Council of Historical Research (ICHR)",
  "Indian Council of Philosophical Research (ICPR),",
  "Indian Council of Social Science Research (ICSSR)",
  "Indian Institute of Advanced Study (IIAS)",
  "Indian Institute of Information Technology , Allahabad",
  "Indian Institute of Information Technology and Management, Gwalior",
  "Indian Institute of Information Technology, Bhagalpur",
  "Indian Institute of Information Technology Design and Manufacturing Kancheepuram",
  "Indian Institute of Information Technology (IIIT) Ranchi",
  "Indian Institute of Information Technology (IIIT) Una Saloh",
  "Indian Institute of Information Technology, Kottayam",
  "Indian Institute of Information Technology, Lucknow",
  "Indian Institute of Information Technology Raichur",
  "Indian Institute of Information Technology, Surat",
  "Indian Institute of Information Technology, Vadodara",
  "Indian Institute of Information Technology,  Pune",
  "Indian Institute of Management (IIM), Ahmedabad",
  "Indian Institute of Management (IIM), Amritsar",
  "Indian Institute of Management (IIM), Bangalore",
  "Indian Institute of Management (IIM), Bodhgaya",
  "Indian Institute of Management (IIM), Indore",
  "Indian Institute of Management (IIM), Jammu",
  "Indian Institute of Management (IIM), Kashipur",
  "Indian Institute of Management (IIM), Kolkata",
  "Indian Institute of Management (IIM), Kozhikode",
  "Indian Institute of Management (IIM), Lucknow",
  "Indian Institute of Management (IIM), Nagpur",
  "Indian Institute of Management (IIM), Raipur",
  "Indian Institute of Management (IIM), Ranchi",
  "Indian Institute of Management (IIM), Rohtak",
  "Indian Institute of Management (IIM), Sambalpur",
  "Indian Institute of Management (IIM), Sirmour",
  "Indian Institute of Management (IIM), Tiruchirapalli",
  "Indian Institute of Management (IIM), Udaipur",
  "Indian Institute of Management (IIM), Vishakhapatnam",
  "Indian Institute of Management, Shillong",
  "Indian Institute of Science, Bangalore",
  "Indian Institute of Science Education and Research (IISER), Berhampur",
  "Indian Institute of Science Education and Research (IISER), Bhopal",
  "Indian Institute of Science Education and Research (IISER), Kolkata",
  "Indian Institute of Science Education and Research (IISER), Mohali",
  "Indian Institute of Science Education and Research (IISER), Pune",
  "Indian Institute of Science Education and Research (IISER), Thiruvananthapuram",
  "Indian Institute of Science Education and Research (IISER),Tirupati",
  "Indian Institute of Science, Engineering & Technology, Shibpur",
  "Indian Institute of Technology, Delhi",
  "Indian Institute of Technology, Dharwad",
  "Indian Institute of Technology, Goa",
  "Indian Institute of Technology, Guwahati",
  "Indian Institute of Technology (IIT), Bhilai",
  "Indian Institute of Technology (IIT), Bhubaneshwar",
  "Indian Institute of Technology (IIT), Gandhinagar",
  "Indian Institute of Technology (IIT), Hyderabad",
  "Indian Institute of Technology (IIT), Indore",
  "Indian Institute of Technology (IIT), Mandi",
  "Indian Institute of Technology (IIT) Patna",
  "Indian Institute of Technology (IIT), ROORKEE",
  "Indian Institute of Technology (IIT), Ropar",
  "Indian Institute of Technology (IIT), Tirupati",
  "Indian Institute of Technology (Indian School of Mines), Dhanbad",
  "Indian Institute of Technology, Jammu",
  "Indian Institute of Technology, Jodhpur",
  "Indian Institute of Technology, Kanpur",
  "Indian Institute of Technology, Kharagpur",
  "Indian Institute of Technology , Madras",
  "Indian Institute of Technology , Mumbai",
  "Indian Institute of Technology, Palakkad",
  "Indira Gandhi National Open University (IGNOU)",
  "JAMIA MILLIA ISLAMIA",
  "Jawaharlal Nehru University, New Delhi",
  "Kendriya Hindi Sansthan, Agra",
  "Maharshi Sandeepani Rashtriya Veda Vidya Pratishthan",
  "Maharshi Sandeepani Rashtriya Ved Vidya Pratishthan",
  "Mahatma Gandhi Antarrashtriya Hindi Vishwavidyalaya",
  "Mahatma Gandhi Central Univesity - Bihar, Motihari",
  "Malavya National Institute of Technology, Jaipur",
  "Manipur University",
  "Maulana Azad National Institute of Technology, Bhopal",
  "Maulana Azad National Urdu University (MANUU)",
  "Mizoram University",
  "Motilal Nehru National Institute of Technology Allahabad",
  "Nagaland University",
  "National Book Trust",
  "National Commission for Minority Educational Institutions",
  "National Council for Promotion of Sindhi Language,",
  "National Council for Promotion of Urdu Language (NCPUL)",
  "National Council of RuralL Institutes (NCRI), Hyderabad",
  "National Institute of Foundry and Forge Technology (NIFFT)",
  "National Institute of Industrial Engineering (NITIE), Mumbai",
  "National Institute of Technical Teachers' Training and Research, Bhopal",
  "National Institute of Technical Teachers' Training and Research, Chandigarh",
  "National Institute of Technology, Agartala",
  "National Institute of Technology, Andhra Pradesh",
  "National Institute of Technology, Arunachal Pradesh",
  "National Institute of Technology, Calicut",
  "National Institute of Technology, Delhi",
  "National Institute of Technology, Durgapur",
  "National Institute of Technology, Goa",
  "National Institute of Technology, Hamirpur",
  "National Institute of Technology, Jamshedpur",
  "National Institute of Technology, Kurukshetra",
  "National Institute of Technology, Manipur",
  "National Institute of Technology, Meghalaya",
  "National Institute of Technology, Mizoram",
  "National Institute of Technology, Nagaland",
  "National Institute of Technology, Patna",
  "National Institute of Technology, Puducherry",
  "National Institute of Technology, Raipur",
  "National Institute of Technology, Rourkela",
  "National Institute of Technology, Sikkim",
  "National Institute of Technology, Silchar",
  "National Institute of Technology, Srinagar",
  "National Institute of Technology, Surthkal",
  "National Institute of Technology, Tiruchirappalli",
  "National Institute of Technology, Uttarakhand",
  "National Institute of Technology, Warangal",
  "National Project Implementation Unit (NPIU)",
  "National Testing Agency",
  "National University of Educational Planning and Administration (NUEPA)",
  "North Eastern Hill University",
  "North Eastern Regional Institute of Science and Technology (NERIST)",
  "PDPM Indian Institute of Information Technology Design and Manufacturing Jabalpur",
  "Pondicherry University",
  "Rajiv Gandhi University",
  "Rashtriya Sanskrit Sansthan",
  "Rashtriya Sanskrit Vidyapeetha",
  "Sant Longowal Institute of Engineering & Technology (SLIET)",
  "School of Open Learning, University of Delhi",
  "School of Planning and Architecture",
  "School of Planning and Architecture (SPA), Bhopal",
  "School of Planning and Architecture (SPA), VIjayawada",
  "Shri Lal Bahadur Shastri National Sanskrit University (Central University)",
  "Sikkim University",
  "S.V. National Institute of Technology, Surat",
  "Tata Institute of Social Sciences (TISS)",
  "Tezpur University",
  "The English and Foreign Languages University",
  "The Indira Gandhi National Tribal University",
  "Tripura University",
  "University Grants Commission (UGC)",
  "University of Allahabad",
  "University of Delhi",
  "University of Hyderabad",
  "Visva-Bharati",
  "Visvesvaraya National Institute of Technology, Nagpur",
  "Central Manufacturing Technology Institute",
  "Central Pulp & Paper Research Iinstitute",
  "Department of Industrial Policy & Promotion",
  "Indian Rubber Manufacturers Research Association",
  "National Council for Cement and Building Materials",
  "National Institute of Design (NID), Ahmedabad",
  "National Institute of Design(NID), Andhra Pradesh",
  "National Institute of Design(NID), Assam",
  "National Institute of Design(NID), Haryana",
  "National Institute of Design(NID), Madhya Pradesh",
  "National Productivity Council",
  "Office of the Controller General of Patents, Designs & Trade Marks",
  "Office of the Economic Adviser",
  "Office of the Salt Commissioner",
  "Petroleum and Explosives Safety Organisation",
  "Quality Council of India",
  "Tariff Commission",
  "Department of Investment and Public Asset Management",
  "Department of Justice",
  "Department of Land Resources",
  "Appellate Tribunal for Foreign Exchange",
  "Bar Council of India",
  "Branch Sectt. Bangalore",
  "Branch Sectt. Chennai",
  "Branch Sectt. Kolkata",
  "Branch Sectt. Mumbai",
  "Central Agency Section,",
  "Department of Legal Affairs",
  "Income Tax Appellate Tribunal, Agra",
  "Income Tax Appellate Tribunal, Ahmedabad",
  "Income Tax Appellate Tribunal, Allahabad",
  "Income Tax Appellate Tribunal, Amritsar",
  "Income Tax Appellate Tribunal, Bangalore",
  "Income Tax Appellate Tribunal, Chandigarh",
  "Income Tax Appellate Tribunal, Chennai",
  "Income Tax Appellate Tribunal, Cochin",
  "Income Tax Appellate Tribunal, Cuttack",
  "Income Tax Appellate Tribunal, Delhi",
  "Income Tax Appellate Tribunal, Guwahati",
  "Income Tax Appellate Tribunal, Hyderabad",
  "Income Tax Appellate Tribunal, Indore",
  "Income Tax Appellate Tribunal, Jabalpur",
  "Income Tax Appellate Tribunal, Jaipur",
  "Income Tax Appellate Tribunal, Jodhpur",
  "Income Tax Appellate Tribunal, Kolkata",
  "Income Tax Appellate Tribunal, Lucknow",
  "Income Tax Appellate Tribunal, Mumbai",
  "Income Tax Appellate Tribunal, Nagpur",
  "Income Tax Appellate Tribunal, Panaji",
  "Income Tax Appellate Tribunal, Patna",
  "Income Tax Appellate Tribunal, Pune",
  "Income Tax Appellate Tribunal, Raipur",
  "Income Tax Appellate Tribunal, Rajkot",
  "Income Tax Appellate Tribunal, Ranchi",
  "Income Tax Appellate Tribunal, Surat",
  "Income Tax Appellate Tribunal, Visakhapatnam",
  "Law Commission of India",
  "NATIONAL LEGAL SERVICES AUTHORITY",
  "Department of Pensions & Pensioners Welfare",
  "National Centre for Good Governance, DARPG",
  "Central Administrative Tribunal (CAT)",
  "Central Information Commission",
  "Central Vigilance Commission (CVC)",
  "Department of Personnel & Training",
  "Indian Institute of Public Administration (IIPA)",
  "Institute of Secretariat Training and Management (ISTM)",
  "Karmayogi Bharat",
  "Lal Bahadur Shastri National Academy of Administration",
  "Staff Selection Commission, Allahabad",
  "Staff Selection Commission,Bengaluru",
  "Staff Selection Commission, Eastern Region",
  "Staff Selection Commission - HQ",
  "Staff Selection Commission, North Eastern Region",
  "Staff Selection Commission - Northern Region",
  "Staff Selection Commission,North Western Region",
  "Staff Selection Commission, Raipur",
  "Staff Selection Commission, Southern Region",
  "Staff Selection Commission, Western Region",
  "Union Public Service Commission",
  "Bengal Chemicals & Pharmaceuticals Ltd.",
  "Department of Pharmaceuticals",
  "Hindustan Antibiotic Ltd.",
  "Indian Drugs & Pharmaceuticals Ltd.",
  "Karnataka Antibiotics & Pharmaceuticals Ltd.",
  "National Institute of Pharmaceutical Education and Research, Mohali",
  "National Institute of Pharmaceutical Education and Research (NIPER),Ahmedabad",
  "National Institute of Pharmaceutical Education and Research (NIPER), Guwahati",
  "National Institute of Pharmaceutical Education and Research (NIPER), Hajipur",
  "National Institute of Pharmaceutical Education and Research (NIPER), Kolkata",
  "National Pharmaceuticals Pricing Authority",
  "NIPER, Hyderabad",
  "NIPER, Rae Bareli",
  "Rajasthan Drugs & Pharmaceuticals Ltd.",
  "Department of Posts",
  "Department of Public Enterprises",
  "Central Board of Direct Taxes",
  "Central Board of Excise and Customs - Central Excise",
  "Central Board of Excise and Customs - Customs",
  "Chief Commisioner of Central Excise (Coimbatore Zone)",
  "Chief Commissioner, Central Excise, Ahmedabad Zone",
  "Chief Commissioner, Central Excise, Bangalore Zone",
  "Chief Commissioner Central Excise,Cochin Zone",
  "Chief Commissioner Central Excise, Customs & Service Tax, Bhubaneswar Zone",
  "Chief Commissioner, Central Excise, Delhi Zone",
  "Chief Commissioner, Central Excise, Mysore Zone",
  "Chief Commissioner, Central Excise & Service Tax, Ranchi Zone,Patna",
  "Chief Commissioner, CGST & Central Excise, Jaipur Zone",
  "Chief Commissioner, CGST & Central Excise, Kolkata Zone",
  "Chief Commissioner, Goods and Services Tax & Customs, Guwahati Zone",
  "Chief Commissioner of Central Excise & Customs, Pune Zone",
  "Chief Commissioner of Central Excise & Customs (Visakhapatnam Zone)",
  "Chief Commissioner of Central Excise, Mumbai-I Zone",
  "Chief Commissioner of Central Goods and Service Tax & Central Excise, Lucknow Zone",
  "Chief Commissioner of Central GST and Central Excise, Vadodara Zone",
  "Chief Commissioner of Central Tax (GST) Customs and Central Excise, Bhopal Zone",
  "Chief Commissioner of Custms & Central Excise, Meerut Zone",
  "Chief Commissioner of Custms & Central Excise, Nagpur Zone",
  "Chief Commissioner of Customs and Central Excise Hyderabad Zone",
  "Chief Commissioner of Customs, Bangalore Zone",
  "Chief Commissioner of Customs, Chennai Zone",
  "Chief Commissioner of Customs, Delhi Zone",
  "Chief Commissioner of Customs, Kolkata Zone",
  "Chief Commissioner of Customs, Mumbai-III Zone",
  "Chief Commissioner of Customs, Mumbai-II Zone",
  "Chief Commissioner of Customs, Mumbai-I Zone",
  "Chief Commissioner of Customs Preventive, Delhi Zone",
  "Chief Commissioner of Customs (Preventive), Tiruchirapalli",
  "Chief Commissioner of Income Tax (CCA) , Patna",
  "Chief Commissioner of Income Tax (Exemption), Delhi",
  "Chief Commissioner of Service Tax (Delhi Zone)",
  "Department of Revenue",
  "Directorate General of Audit",
  "Directorate General of Export Promotion",
  "Directorate General of Goods and Services Tax (DGGST)",
  "Directorate General of Goods and Service Tax Intelligence",
  "Directorate General of Human Resource Development",
  "Directorate General of Income Tax (Intelligence & Criminal Investigations)",
  "Directorate General of Performance Management",
  "Directorate General of Safeguards, Customs & Central Excise, New Delhi",
  "Directorate General of Systems & Data Management",
  "Directorate General of Tax Payer Services",
  "Directorate General of Valuation",
  "Directorate General of Vigilance (HQ),New Delhi",
  "Directorate of International Customs",
  "Directorate of Logistics",
  "Directorate of Revenue Intelligence",
  "Director General of Income Tax (HRD), New Delhi",
  "Director General of Income Tax (Inv.), Ahmedabad",
  "Director General of Income Tax (Inv.) Bangalore",
  "Director General of Income Tax (Inv.) Bhopal",
  "Director General of Income Tax (Inv.) Chandigarh",
  "Director General of Income Tax(Inv.),Chennai",
  "Director General of Income Tax (Inv.) Hyderabad",
  "Director General of Income Tax (Inv.) Jaipur",
  "Director General of Income Tax(Inv.) Kochi",
  "Director General of Income Tax (Inv.), Lucknow",
  "Director General of Income Tax (Inv.) Mumbai",
  "Director General of Income Tax (Inv.) New Delhi",
  "Director General of Income Tax (Inv). Patna",
  "Director General of Income Tax (Inv.) Pune",
  "Director General of Income Tax (Inv.)West Bengal, Sikkim & NER",
  "Director General of Income Tax (Legal and Research)",
  "Director General of Income Tax (Logistics)",
  "Director General of Income Tax (NADT), Nagpur",
  "Director General of Income Tax (Systems) ,New Delhi",
  "Director General of Income Tax (Vigilance), New Delhi",
  "Financial Intelligence Unit",
  "GST Council",
  "Large Taxpayer Unit (Audit), Delhi",
  "Large TaxPayer Unit, Banagalore",
  "National Academy Of Customs Excise And Narcotics",
  "Office of the Chief Commissioner, Central GST & Central Excise, Panchkula Zone",
  "OFFICE OF THE CHIEF COMMISSIONER OF CUSTOMS GUJARAT ZONE",
  "Office of the Chief Commissioner of GST, Chandigarh Zone",
  "Pr. Chief Commissioner of Customs ☎ Zone, Patna",
  "Pr. Chief Commissioner of Income Tax (CCA), Guwahati",
  "Pr. Chief Commissioner of Income Tax (CCIT) , Lucknow",
  "Pr. Chief Commissioner of Income Tax (International Taxation) New Delhi",
  "Principal Chief Commisioner of Income Tax (CCA), New Delhi",
  "Principal Chief Commissioner of Central Excise, Chennai Zone",
  "Principal Chief Commissioner of Income Tax (CCA), Bangalore",
  "Principal Chief Commissioner of Income Tax (CCA) , Bhopal",
  "Principal Chief Commissioner of Income Tax (CCA) , Bhubaneswar",
  "Principal Chief Commissioner of Income Tax (CCA) , Chandigrah",
  "Principal Chief Commissioner of Income Tax (CCA), Chennai",
  "Principal Chief Commissioner of Income Tax (CCA) , Jaipur",
  "Principal Chief Commissioner of Income Tax (CCA) , Kanpur",
  "Principal Chief Commissioner of Income Tax (CCA) , Kolkata",
  "Principal Chief Commissioner of Income Tax (CCA) , Nagpur",
  "Principal Chief Commissioner of Income Tax (CCA), Pune",
  "Principal Chief Controller of Accounts-CBIC",
  "Prinicipal Chief Commissioner of Income Tax (CCA) , Ahmedabad",
  "Prinicipal Chief Commissioner of Income Tax (CCA) , Hyderabad",
  "Prinicipal Chief Commissioner of Income Tax (CCA) , Kochi",
  "Prinicipal Chief Commissioner of Income Tax (CCA) , Mumbai",
  "Central Board of Secondary Education",
  "Central Tibetan Schools Administration, Delhi",
  "Department of School Education and Literacy",
  "Directorate of Adult Education",
  "Kendriya Vidyalaya Sangathan",
  "National Bal Bhavan",
  "National Council for Teacher Education",
  "National Council of Educational Research & Training",
  "National Institute of Open Schooling",
  "Navodaya Vidyalaya Samiti",
  "Aghakar Research Institute",
  "Aryabhatta Research Institute of Observational Sciences",
  "Birbal Sahni Institute of Palaeosciences (BSIP)",
  "Bose Institute",
  "Centre for Nano and Soft Matter Sciences",
  "Chief Controller of Accounts-DST",
  "Department of Science & Technology",
  "Indian Academy of Sciences",
  "Indian Assoication for the Cultivation of Science",
  "Indian Institute of Astrophysics",
  "Indian Institute of Geomagnetism",
  "Indian National Academy of Engineering",
  "Indian National Science Academy",
  "Indian Science Congress Association",
  "Indo-U.S. Science and Technology Forum",
  "Institute of Advanced Study in Science and Technology",
  "Institute of Nano Science & Technology, Mohali",
  "International Advanced Research Centre for Powder Metallurgy",
  "Jawarhal Lal Nehru Centre for Advanced Scientific Research",
  "National Academy of Sciences",
  "National Atlas & Thematic Mapping Organisation",
  "National Innovation Foundation- India (NIF)",
  "North East Centre for Technology Application & Reach (NECTAR)",
  "Raman Research Institute",
  "Science & Engineering Research Board",
  "Shree Chitra Triunal Institute for Medical Sciences and Technology",
  "S.N. Bose National Centre for Basic Sciences",
  "Survey of India",
  "Technology Development Board",
  "Technology Information, Forecasting and Assessment Council",
  "Vigyan Prasar",
  "Wadia Institute of Himalayan Geology",
  "Central Electronics Limited",
  "Consultancy Development Centre",
  "CSIR - Academy of Scientific and Innovative Research (ACSIR)",
  "CSIR-Advanced Materials and Process Research Institute (AMPRI), Bhopal",
  "CSIR-Central Building Research Institute (CSIR-CBRI)",
  "CSIR- Central Drug Research Institute (CDRI)",
  "CSIR - Central Electronics Engineering Research Institute (CEERI),Pilani",
  "CSIR-Central Eletrochemical Research Institute (CECRI),Karaikudi",
  "CSIR-Central Food Technological Research Institute (CSIR- CFTRI)",
  "CSIR- Central Glass & Ceramic Research Institute (CGCRI), Kolkata",
  "CSIR-Central Institute of Medicinal and Aromatic Plants (CIMAP),Lucknow",
  "CSIR-Central Institute of Mining & Fuel Research (CIMFR), Dhanbad",
  "CSIR-Central Leather Research Institute (CSIR-CLRI)",
  "CSIR-Central Mechanical Engineering Research Institute (CMERI)",
  "CSIR-Central Road Research Institute (CRRI)",
  "CSIR-Central Salt & Marine Chemicals Research Institute (CSMCRI)",
  "CSIR-Central Scientific Instrument Oorganisation (CSIO),Chandigarh",
  "CSIR-Centre for Cellular and Molecular Biology (CCMB)",
  "CSIR-Fourth Paradigm Institute",
  "CSIR Hqrs.,New Delhi",
  "CSIR-Human Resource Development Group",
  "CSIR-Indian Institute of Chemical Biology (CSIR-IICB)",
  "CSIR-Indian Institute of Chemical Technology (IICT),Hyderabad",
  "CSIR-Indian Institute of Integrative Medicine (IIIM)",
  "CSIR-Indian Institute of Petroleum",
  "CSIR-Indian Institute of Toxicology Research (CSIR-IITR)",
  "CSIR-Institute of Genomics & Integrative Biology (CSIR-IGIB)",
  "CSIR-Institute of Himalayan Bioresource Technology (CSIR-IHBT)",
  "CSIR-Institute of Microbial Technology (CSIR-IMT)",
  "CSIR-Institute of Minerals & Materials Technology (IMMT)",
  "CSIR Madras Complex",
  "CSIR-National Aerospace Laboratories (CSIR-NAL)",
  "CSIR-National Botanical Research Institute (CSIR- NBRI)",
  "CSIR-National Chemical Laboratory (CSIR-NCL)",
  "CSIR- National Environmental Engineering Research Institute (NEERI)",
  "CSIR-National Geophysical Research Institute (CSIR- NGRI)",
  "CSIR- National Institute for Interdisciplinary Science and Technology (NIIST)",
  "CSIR- National Institute for Science Communication and Ploicy Research (NIScPR), New Delhi",
  "CSIR-National Institute of Oceanography (CSIR-NIO)",
  "CSIR - National Institute of Science Communication and Information Resources",
  "CSIR- National Metallurgical Laboratory (NML),Jamshedpur",
  "CSIR- National Physical Laboratory (NPL)",
  "CSIR-North East Institute of Science and Technology (CSIR-NEIST)",
  "CSIR-Structural Engineering Research Centre (CSIR_SERC)",
  "Department of Scientific & Industrial Research",
  "National Research Development Corporation",
  "Advanced Data Processing Research Institute, Secunderabad",
  "Antrix Corporation Limited, Bengaluru",
  "Department of Space",
  "Human Space Flight Centre (HSFC)",
  "Indian Institute of Remote Sensing, Dehradun",
  "Indian Institute of Space Science and Technology, Thiruvananthapuram",
  "ISRO Headquarters, Bengaluru",
  "ISRO Propulsion Complex, Mahendragiri",
  "ISRO Telemetry, Tracking & Commannd Network (Bengaluru, Lucknow, Port Blair, Sriharikota)",
  "Liquid Propulsion Systems Centre, Valiamala & Bengaluru",
  "Master Control Facility, Hassan & Units",
  "National Atmospheric Research Laboratory, Gadanki",
  "National Remote Sensing Centre (Hyderabad,Bengaluru, Jodhpur, Kolkata, Nagpur, Delhi)",
  "New Space India Limited",
  "North Eastern Space Application Centre, Shillong",
  "Physical Research laboratory, Ahmedabad",
  "SDSC-SHAR, Shriharikota & N2O4 Plant, Propellant Complex, Rasayani Unit,Raigadh Distt. Mumbai",
  "Space Application Centre & Development and Educational Communication Unit, Ahmedabad",
  "U R Rao Sattelite Centre, Bengaluru & Laboratory for Electro-Optics Systems, Bengaluru",
  "VSSC,ISRO-IISU Thiruvananthapuram & APEP Aluva",
  "Bharat Broadband Network Limited",
  "Bharat Sanchar Nigam Limited - HQ",
  "BSNL ALTTC GHAZIABAD",
  "BSNL ANDHRA PRADESH",
  "BSNL ANDMAN & NICOBAR",
  "BSNL ASSAM",
  "BSNL BBNW",
  "BSNL BIHAR",
  "BSNL CHENNAI TD",
  "BSNL CHHATTISGARH",
  "BSNL CNTx (East)",
  "BSNL CNTx (North)",
  "BSNL CNTx (West)",
  "BSNL GUJRAT",
  "BSNL HARYANA",
  "BSNL HIMACHAL PRADESH",
  "BSNL ITPC PUNE",
  "BSNL JHARKHAND",
  "BSNL J&K",
  "BSNL KARNATAKA",
  "BSNL KERALA",
  "BSNL MADHYA PRADESH",
  "BSNL MAHARASHTRA",
  "BSNL NE- I",
  "BSNL NE- II",
  "BSNL NETF",
  "BSNL NFS",
  "BSNL ODISHA",
  "BSNL PUNJAB",
  "BSNL QA & INSPECTION",
  "BSNL RAJASTHAN",
  "BSNL SIKKIM",
  "BSNL STP CHENNAI",
  "BSNL STR CHENNAI",
  "BSNL TAMILNADU",
  "BSNL Telangana",
  "BSNL TELECOM STORE KOL",
  "BSNL UP(E)",
  "BSNL UP(W)",
  "BSNL UTTRAKHAND",
  "BSNL WEST BENGAL",
  "Centre for Development of Telematics (C-DoT)",
  "Controller General of Communication Accounts (CGCA)",
  "Department of Telecommunications",
  "Director General (Telecom) HQ",
  "Indian Telephone Industries Ltd. (ITI Ltd.)",
  "MTNL- Corporate Office",
  "MTNL-Delhi office",
  "MTNL-Mumbai Office",
  "Telecom Disputes Settlement & Appellate Tribunal (TDSAT)",
  "Telecommunications Consultants India Limited (TCIL)",
  "Telecom Regulatory Authority of India",
  "Wireless Monitoring Organisaton Hqrs (WMO)",
  "Food Safety & Standards Authority of India(FSSAI)",
  "Legislative Department",
  "LOKPAL",
  "Lok Sabha Secretariat",
  "All india Institute of Ayurveda",
  "Board of Ethics and Registration for Homoeopathy (BERH)",
  "Central Council for Research in Siddha",
  "Central Council for Research in Unani Medicine(CCRUM)",
  "Central Poultry Performance Testing Centre , Gurugram",
  "Homoeopathy Education Board (HEB)",
  "Indian Medicine Pharmaceutical Corporation Limited IMPCL",
  "Medical Assessment and Rating Board for Homoeopathy (MARBH)",
  "Ministry of AYUSH",
  "National Commission for Homoeopathy",
  "National Institute of Ayurveda (NIA)",
  "National Institute of Homoeopathy",
  "National Institute of Indian Medical Heritage",
  "National Institute of Naturopathy",
  "National Institute of Siddha",
  "National Institute of Unani Medicine (NIUM)",
  "National Medicinal Plants Board",
  "Pharmacopoeia Commission for Indian Medicine and Homoeopathy (PCIM&H)",
  "Rashtriya Ayurveda Vidyapeeth",
  "Board of Ethics and Registration for Homeopathy",
  "Rating Board for Homeopathy, NCH",
  "AAI-Airport Director, Chennai Airport",
  "AAI-Airport Director, Kolkata Airport",
  "AAI-Eastern Region, Kolkata",
  "AAI-North East Region, Guwahati",
  "AAI-Northern Region, Delhi",
  "AAI-Southern Region, Chennai",
  "AAI-Western Region, Mumbai",
  "Airports Authority of India",
  "Airports Economic Regulatory Authority of India",
  "Bureau of Civil Aviation Security",
  "Commission of Railway Safety",
  "Director General of Civil Aviation",
  "Indira Gandhi Rashtriya Uran Akademi",
  "Ministry of Civil Aviation",
  "Pawan Hans Limited",
  "Rajiv Gandhi National Aviation University",
  "Central Coalfield Limited",
  "Central Mine Planning and Design Institute",
  "Coal India Limited",
  "Eastern Coalfields Limited",
  "Mahanadi Coalfiels Limited",
  "Ministry of Coal",
  "NLC India Limited",
  "North Eastern Coalfields",
  "Northern Coalfield Ltd.",
  "South Eastern Coalfields Ltd.",
  "Western Coalfileds Limited",
  "Ministry of Cooperation",
  "Central Registration Centre, Manesar",
  "Competition Commission of India",
  "Indian Institute of Corporate Affairs, Manesar (IICA Manesar)",
  "Insolvency and Bankruptcy Board of India",
  "Investor Education And Protection Fund Authority (IEPF Authority)",
  "Ministry of Corporate Affairs",
  "National Company Law Appellate Tribunal",
  "National Company Law Tribunal, Ahmedabad",
  "National Company Law Tribunal, Chandigarh",
  "National Company Law Tribunal, Guwahati",
  "National Company Law Tribunal, Hyderabad",
  "National Company Law Tribunal, Kolkata Bench",
  "National Company Law Tribunal, Mumbai",
  "National Company Law Tribunal, Prinicpal Bench",
  "National Financial Reporting Authority (NFRA)",
  "Official Liquidator, Bengaluru",
  "Official Liquidator, Chandigarh",
  "Official Liquidator, Delhi",
  "Official Liquidator, Gujarat",
  "Official Liquidator, Guwahati",
  "Official Liquidator, Hyderabad",
  "Official Liquidator, Jodhpur",
  "Official Liquidator, Kerala",
  "Official Liquidator, Madhya Pradesh",
  "Official Liquidator, Maharashtra",
  "Official Liquidator, Nagpur",
  "Official Liquidator, Tamil Nadu",
  "Official Liquidator, Uttar Pradesh",
  "Official Liquidator, West Bengal",
  "Regional Director(ER),Kolkata",
  "Regional Director(NR), New Delhi",
  "Regional Director(NWR), Ahmedabad",
  "Regional Director(SER), Hyderabad",
  "Regional Director(SR), Chennai",
  "Regional Director(WR),Mumbai",
  "Registrar of Companies, Ahmedabad",
  "Registrar of Companies, Andhra Pradesh",
  "Registrar of Companies, Bengaluru",
  "Registrar of Companies, Coimbatore",
  "Registrar of Companies, Delhi and Haryana",
  "Registrar of Companies, Gwalior",
  "Registrar of Companies, Hyderabad",
  "Registrar of Companies, Kanpur & Nainital",
  "Registrar of Companies, Kochi",
  "Registrar of Companies, Mumbai",
  "Registrar of Companies & Official Liquidator, Chhattisgarh",
  "Registrar of Companies & Official Liquidator, Goa",
  "Registrar of Companies & Official Liquidator, Himachal Pradesh",
  "Registrar of Companies & Official Liquidator, Jammu & Kashmir",
  "Registrar of Companies & Official Liquidator, Jharkhand",
  "Registrar of Companies & Official Liquidator, Orissa",
  "Registrar of Companies & Official Liquidator, Patna, Bihar",
  "Registrar of Companies & Official Liquidator, Rajasthan",
  "Registrar of Companies, Puducherry",
  "Registrar of Companies, Pune",
  "Registrar of Companies, Punjab",
  "Registrar of Companies, Shillong",
  "Registrar of Companies, Tamil Nadu",
  "Registrar of Companies, UP(Kanpur)",
  "Registrar of Companies, West Bengal",
  "Serious Fraud Investigation Office",
  "The Institute of Chartered Accountants of India",
  "The Institute of Company Secretaries of India",
  "The Institute of Cost Accountants of India",
  "Allahabad Museum",
  "Anthropological Survey of India",
  "Archaeological Survey of India",
  "Asiatic Society",
  "Central Institute of Buddhist Studies.",
  "Central Institute of Himalayan Culture Studies",
  "Central Reference Library",
  "Central University of Tibetan Studies.",
  "Centre for Cultural Resources and Training.",
  "Delhi Public Library",
  "Eastern Zonal Cultural Centre",
  "Gandhi Smriti Darshan Samiti",
  "Indira Gandhi National Centre for the Arts",
  "Indira Gandhi Rashtriya Manav Sangrahalaya",
  "Kalakshetra Foundation",
  "Khuda Bakhsh Oriental Public Library",
  "Lalit Kala Akademi",
  "Maulana Abul Kalam Azad Institute of Asian Studies.",
  "Ministry of Culture",
  "National Archives of India",
  "National Council of Science Museums.( Hqrs./CRTL)",
  "National Culture Fund",
  "National Gallery of Modern Arts, Bangalore",
  "National Gallery of Modern Arts, Delhi",
  "National Gallery of Modern Arts, Mumbai",
  "National Library, Kolkata",
  "National Monuments Authority (NMA)",
  "National Museum",
  "National Museum Institute of History of Art Conservation and Museology",
  "National Research Laboratory for Conservation of Cultural Property.",
  "National School of Drama",
  "Nava Nalanda Mahavihara",
  "Nehru Memorial Museum & Library",
  "North Central Zone Cultural Centre Allahabad",
  "North East Zone Cultural Centre",
  "North Zone Cultural Centre, Patiala",
  "Raja Rammohan Roy Library Foundation.",
  "Rampur Raza Library",
  "Sahitya Akademi",
  "Salar Jung Museum",
  "Sangeet Natak Akademi",
  "South Central Zone Cultural Centre",
  "South Zone Cultural Centre",
  "Victoria Memorial Hall",
  "West Zone Cultural Centre",
  "Ministry of Development of North Eastern Region",
  "North Eastern Council (NEC)",
  "North Eastern Development Finance Corp. (NEDFi)",
  "North Eastern Handicrafts and Handlooms Development Corporation(NEHHDC)",
  "North Eastern Regional Agricultural Marketing Corporation (NERAMAC)",
  "Ministry of Drinking Water and Sanitation",
  "Centre for Marine Living Resources and Ecology",
  "India Meteorological Department",
  "Indian Institute of Tropical Meteorology",
  "Indian National Centre for Ocean Information Services",
  "Integrated Coastal and Marine Area Management (ICMAM) Project Directorate",
  "Ministry of Earth Sciences",
  "National Centre for Earth Science Studies, Trivandrum",
  "NATIONAL CENTRE FOR MEDIUM RANGE WEATHER FORECASTING",
  "National Centre for Polar and Ocean Research",
  "National Institute of Ocean Technology",
  "Principal Accounts Officer, Ministry of Earth Sciences",
  "Department of Higher Education",
  "Department of School Education and Literacy",
  "IIIT Bhopal",
  "IIIT Dharwad",
  "Indian Institute of Information Technology Sonepat",
  "Institute of Digital Education and Employment Development",
  "Mechanical Engineering, IIITDM, Kurnool",
  "Ministry of Education",
  "National Board of Accreditation",
  "IIM Visakhapatnam",
  "Indian Institute of Information Technology Sri City Chittoor",
  "Andaman & Nicobar Forest Plantation Development Corporation, Port Blair",
  "Animal welfare Board of India, Chennai",
  "Botanical Survey of India, Kolkata",
  "Central Pollution Control Board, Delhi",
  "Central Regional Office, Lucknow (Ministry of Environment, Forest & Climate Control)",
  "Central Zoo Authority, New Delhi",
  "DDGF, Integrated Regional Office, GANDHINAGAR",
  "DDGF, Integrated Regional Office, HYDERABAD",
  "DDGF, Integrated Regional Office, KOLKATA",
  "DDGF, Integrated Regional Office, RAIPUR",
  "DIGF, Integrated Regional Office, JAMMU",
  "Directorate of Forest Education, Dehradun",
  "Forest Survey of India, Dehradun",
  "Gobind Ballabh Pant Institute of Himalayan Environment and Development, Almora",
  "IGF, Integrated Regional Office, GUWAHATI",
  "IGF, Integrated Regional Office, SHIMLA",
  "IGF, Integrated Regional Office, VIJAYAWADA",
  "Indian Council of Forestry Research and Education, Dehradun",
  "Indian Institute of Forests Management, Bhopal",
  "Indian Plywood Industries Research and Training Institute, Bangalore",
  "Indira Gandhi National Forest Academy, Dehradun",
  "Integrated Regional Office, Jaipur",
  "Integrated Regional Office, Raipur",
  "Ministry of Environment, Forest and Climate Change",
  "National Afforestation and Eco-Development Board (NAEB)",
  "National Biodiversity Authority",
  "National Centre for Sustainable Coastal Management",
  "National Green Tribunal",
  "National Museum of Natural History, New Delhi",
  "National Tiger Conservation Authority",
  "National Zoological Park, New Delhi",
  "North Eastern Regional Office, Shillong (Ministry of Environment, Forest & Climate Control)",
  "Northern Regional Office, Chandigarh (Ministry of Environment, Forest & Climate Control)",
  "Regional Office,Bangalore (Ministry of Environment, Forest & Climate Control)",
  "Regional Office, Bhopal",
  "Regional Office, Bhubaneshwar, (Ministry of Environment, Forest & Climate Control)",
  "Regional Office, Eastern - Central Zone, Ranchi (Ministry of Environment, Forest & Climate Control)",
  "Regional Office, North- Central Zone, Dehradun (Ministry of Environment, Forest & Climate Control)",
  "Regional Office, South- Eastern Zone, Chennai (Ministry of Environment, Forest & Climate Control)",
  "Regional Office, West-Central Zone, Nagpur (Ministry of Environment, Forest & Climate Control)",
  "Salim Ali Center for Ornithology and Natural History (SACON)",
  "Wildlife Crime Control Bureau",
  "Wildlife Crime Control Bureau, Eastern Region, Kolkatta",
  "Wildlife Crime Control Bureau, Southern Region, Chennai",
  "Wildlife Institute of India, Dehradun",
  "Zoological Survey of India, Kolkata",
  "Assistant High Commission of India, Chittagong",
  "Assistant High Commission of India, Khulna",
  "Consulate General of India, Atlanta",
  "Consulate General of India, Bali",
  "Consulate General of India, Birgunj",
  "Consulate General of India, Birmingham",
  "Consulate General of India, Cape Town",
  "Consulate General of India, Chicago",
  "Consulate General of India, Dubai",
  "Consulate General of India, Durban",
  "Consulate General of India, Edinburgh",
  "Consulate General of India, Erbil",
  "Consulate General of India, Frankfurt",
  "Consulate General of India, Guangzhou",
  "Consulate General of India, Hambantota, Sri Lanka",
  "Consulate General of India, Herat",
  "Consulate General of India, Ho Chi Minh City, Vietnam",
  "Consulate General of India, Hong Kong",
  "Consulate General of India, Houston",
  "Consulate General of India, Istanbul, Turkey",
  "Consulate General of India, Jaffna",
  "Consulate General of India, Jalalabad",
  "Consulate General of India, Jeddah,",
  "Consulate General of India, Kandahar",
  "Consulate General of India, Mandalay",
  "Consulate General of India, Mazar-e-sharif",
  "Consulate General of India, Melbourne",
  "Consulate General of India Milan, Italy",
  "Consulate General of India Munich",
  "Consulate General of India, New York ,USA",
  "Consulate General of India Osaka- Kobe",
  "Consulate General of India, Phuentsholing",
  "Consulate General of India, San Francisco",
  "Consulate General of India, Sao Paulo",
  "Consulate General of India, Shanghai",
  "Consulate General of India, Sittwe, Myanmar",
  "Consulate General of India, St. Petersburg",
  "Consulate General of India, Sydney",
  "Consulate General of India, Vanacouver",
  "Consulate General of India, Vladivostok",
  "Consulate General of India, Zanzibar",
  "Consulate of India, Bandar Abbas",
  "Consulate of India, Zahidan",
  "E/I Baku",
  "E/I Toronto",
  "Embassy of India, Abidjan",
  "Embassy of India, Abu Dhabi",
  "Embassy of India, Addis Ababa",
  "Embassy of India, Algiers",
  "Embassy of India, Amman",
  "Embassy of India, Ankara",
  "Embassy of India, Antananarivo",
  "Embassy of India, Ashgabat",
  "Embassy of India, Astana",
  "Embassy of India, Athens",
  "Embassy of India, Baghdad",
  "Embassy of India, Bahrain",
  "Embassy of India, Bamako",
  "Embassy of India, Bangkok",
  "Embassy of India, Beijing",
  "Embassy of India, Beirut",
  "Embassy of India, Belgrade",
  "Embassy of India, Berlin",
  "Embassy of India, Berne",
  "Embassy of India, Bishkek",
  "Embassy of India, Bogota",
  "Embassy of India,Brasilia",
  "Embassy of India, Bratislava",
  "Embassy of India, Brazzaville",
  "Embassy of India, Brussels",
  "Embassy of India, Bucharest",
  "Embassy of India, Budapest",
  "Embassy of India, Buenos Aires",
  "Embassy of India, Cairo",
  "Embassy of India, Caracas",
  "Embassy of India, Conakry",
  "Embassy of India, Copenhagen",
  "Embassy of India, Dakar",
  "Embassy of India, Damascus",
  "Embassy of India, Djibouti",
  "Embassy of India, Doha",
  "Embassy of India, Dublin",
  "EMBASSY OF INDIA, DUSHANBE",
  "Embassy of India, Guatemala",
  "Embassy of India, Hanoi, Vietnam",
  "Embassy of India,Harare, Zimbabwe",
  "Embassy of India, Havana",
  "Embassy of India, Helsinki, Finland",
  "Embassy of India, Jakarta, Indonesia",
  "Embassy of India, Juba",
  "Embassy of India, Kabul",
  "Embassy of India, Kathmandu",
  "Embassy of India, Khartoum",
  "Embassy of India, Kinshasa",
  "Embassy of India, Kuwait",
  "Embassy of India, Kyiv",
  "Embassy of India, Lima",
  "Embassy of India, Lisbon",
  "Embassy of India, Ljubljana",
  "Embassy of India, Lome (Togo)",
  "Embassy of India, Luanda,",
  "Embassy of India, Madrid,",
  "Embassy of India, Manila",
  "Embassy of India, Mexico",
  "Embassy of India, Minsk",
  "Embassy of India, Moscow",
  "Embassy of India Muscat",
  "Embassy of India, Niamey",
  "Embassy of India, Oslo",
  "Embassy of India,Paramaribo",
  "Embassy of India, Paris",
  "Embassy of India, Pyongyang",
  "Embassy of India, Rome, Italy",
  "Embassy of India, Sanaa",
  "Embassy of India, Santiago",
  "Embassy of India-Santo Domingo, Dominican Republic",
  "Embassy of India, Seoul",
  "Embassy of India, Sofia",
  "Embassy of India, Stockholm",
  "Embassy of India, Tashkent",
  "Embassy of India, Tehran",
  "Embassy of India, Tel Aviv",
  "Embassy of India, The Hague",
  "Embassy of India, Thimphu",
  "Embassy of India, Tokyo",
  "Embassy of India, Tripoli",
  "Embassy of India, Tunis",
  "Embassy of India, Ulaanbaatar",
  "Embassy of India, Vienna",
  "Embassy of India, Vientiane",
  "Embassy of India, Warsaw",
  "Embassy of India, Washington DC",
  "Embassy of India, Yangon",
  "Embassy of India, Yerevan",
  "Embassy of India, Zagreb",
  "Embassy of India Tallinn, Estonia",
  "Hamburg",
  "HCI, Johannesburg",
  "HCI, Malta",
  "HCI Pretoria",
  "High Commission of India, Abuja",
  "High Commission of India, Accra",
  "High Commission of India, Brunei",
  "High Commission of India, Canberra",
  "High Commission of India, Colombo",
  "High Commission of India, Dar es Salaam",
  "High Commission of India, Dhaka",
  "High Commission of India, Gaborone",
  "High Commission of India, Georgetown",
  "High Commission of India, Islamabad, Pakistan,",
  "High Commission of India, Kampala",
  "High Commission of India, Kigali",
  "High Commission of India, Kingston",
  "High Commission of India, Kuala Lumpur",
  "High Commission of India, Lagos",
  "High Commission of India, Lilongwe",
  "High Commission Of India, London",
  "High Commission of India Lusaka, Zambia",
  "High Commission of India, Male",
  "High Commission of India, Maputo",
  "High Commission of India, Mbabane",
  "High Commission of India Nairobi",
  "High Commission of India, Nicosia, Cyprus,",
  "High Commission of India, Port of Spain",
  "High Commission of India, Singapore",
  "High Commission of India, Suva",
  "High Commission of India, Victoria",
  "High Commission of India, Wellington",
  "High Commission of India, Windhoek",
  "High Commission of India, Yaounde",
  "Kandy, Sri Lanka, HCI",
  "MEA - Consular, Passport & Visa Division (CPV)",
  "MEA - Indian Council for Cultural Relations",
  "MEA - Indian Council of World Affairs",
  "Medan, Indonesia,",
  "Ministry of External Affairs",
  "Mombasa",
  "Nalanda University",
  "New York, Permanent Mission of India",
  "Ottawa",
  "Panama City",
  "Permanent Mission of India, Geneva",
  "Perth",
  "Phnom Penh",
  "Port Louis",
  "Port Moresby",
  "Prague",
  "Rabat",
  "Rajshahi",
  "Representative office of India, Ramallah City",
  "Reykjavik",
  "Riyadh",
  "Saint Denis",
  "Ministry of Food Processing Industries",
  "Assam Rifles",
  "Border Security Force",
  "Central Bureau of Investigation (CBI)",
  "Central Industrial Security Force (CISF)",
  "Central Reserve Police Force (CRPF)",
  "Central Translation Bureau, Department of Official Language, MHA",
  "Delhi Police",
  "Department of Official Language",
  "Directorate of Coordination Police Wireless",
  "Directorate of Forensic Science Services",
  "Indo Tibetan Border Police",
  "Intelligence Bureau",
  "Inter State Council",
  "LNJP National Institute of Criminology & Forensic Science",
  "Ministry of Home Affairs",
  "Narcotics Control Bureau, R K Puram",
  "National Crime Record Bureau",
  "National Forensic Sciences University",
  "National Foundation for Communal Harmony",
  "National Human Rights Commission",
  "National Security Guard",
  "Rashtriya Raksha University, Gujarat",
  "Sashastra Seema Bal",
  "Zonal Council Secretariat",
  "Building Material and Technology Promotion Council",
  "Central Govt. Employees Welfare Housing Organisation",
  "Chief Engineer, NCR Zone, CPWD",
  "CPWD ADG (Region Guwahati)",
  "CPWD- Headquarters",
  "CPWD Hyderabad Region",
  "CPWD Project Region Chandigarh",
  "CPWD Project Region Chennai",
  "CPWD Project Region Delhi",
  "CPWD Project Region Kolkata",
  "CPWD Project Region Mumbai",
  "CPWD Region Bangalore",
  "CPWD-Region Chennai",
  "Delhi Development Authority",
  "Delhi Metro Rail Corporation",
  "Delhi Urban Art Commission",
  "Department of Publication",
  "Directorate of Estates",
  "Directorate of Printing",
  "Government of India Stationery Office",
  "Hindustan Prefab Ltd.",
  "Housing and Urban Development Corporation Ltd.",
  "Land and Development Office",
  "Ministry of Housing & Urban Affairs",
  "National Building Construction Corporation Limited",
  "National Building Organization",
  "National Capital Region Planning Board",
  "National Institute of Urban Affairs",
  "Principal Accounts Office, M/o HUA",
  "Rajghat Samadhi Committee",
  "Superintending Engineer-Mussoori",
  "Town and Country Planning Organisation",
  "Tyagraj Marg Project Zone, CPWD",
  "Broadcast Engineering Constulatants India Ltd",
  "Central Board of Film Certification(CBFC)",
  "Central Bureau of Communication (CBC)",
  "Childrens Film Society India",
  "Directorate of Film Festivals",
  "Electronic Media Monitoring Centre",
  "Film and Television Institute, Pune",
  "Films Division",
  "Indian Institute of Mass Communication",
  "Ministry of Information & Broadcasting",
  "National Film Archives of India (NFAI)",
  "National Film Development Corporation of India",
  "New Media Wing",
  "PAY AND ACCOUNTS OFFICE, DOORDARSHAN, GUWAHATI",
  "Prasar Bharti",
  "Press Council of India",
  "Press Information Bureau",
  "Principal Accounts Office, M/o I&B",
  "Publication Division",
  "Registrar of Newspapers of India",
  "Satyajit Ray Film and Television Institute",
  "Board of Arbitration",
  "Central Board for Workers Education",
  "Central Government Industrial Tribunal-cum-Labour Court, Ahmedabad",
  "Central Government Industrial Tribunal-cum-Labour Court, Asansole",
  "Central Government Industrial Tribunal-cum-Labour Court, Bangalore",
  "Central Government Industrial Tribunal cum Labour Court, Bhubneshwar",
  "Central Government Industrial Tribunal-cum-Labour Court, Chandigarh.I",
  "Central Government Industrial Tribunal-cum-Labour Court, Ernakulam, Cochin",
  "Central Government Industrial Tribunal-cum-Labour Court, Guwahati",
  "Central Government Industrial Tribunal-cum-Labour Court, Jabalpur",
  "Central Government Industrial Tribunal-cum-Labour Court, Jaipur",
  "Central Government Industrial Tribunal-cum-Labour Court, Kanpur",
  "Central Government Industrial Tribunal-cum-Labour Court, Kolkata",
  "Central Government Industrial Tribunal-cum-Labour Court, Lucknow",
  "Central Government Industrial Tribunal-cum-Labour Court, Nagpur",
  "Central Govt. Industrial Tribunal cum Labour court, Chennai",
  "CGIT, Hyderabad",
  "CGIT no. I, Delhi",
  "CGIT no. I, Dhanbad",
  "CGIT no. II, Chandigarh",
  "CGIT no. II, Delhi",
  "CGIT no. II, Dhanbad",
  "CGIT no.I I, Mumbai",
  "CGIT no. I, Mumbai",
  "Directorate General Factory Advice Service and Labour Institutes",
  "Directorate General of Employment",
  "Directorate General of Labour & Welfare, Head Quarter",
  "Directorate General of Mines Safety",
  "Employees Provident Fund Organisation",
  "Employees State Insurance Corporation",
  "ESIC Model Hospital Industrial Area II Chandigarh",
  "Ministry of Labour & Employment",
  "Labour Bureau",
  "Office of The Chief Labour Commissioner (Central)",
  "Office of the RLC🆒 Ahmedabad",
  "Office of the RLC🆒, Nagpur",
  "Office of the Welfare Commissioner, Ahmedabad",
  "Office of the Welfare Commissioner, Ajmer",
  "Office of The Welfare Commissioner, Allahabad",
  "Office of the Welfare Commissioner, Bangalore",
  "Office of the Welfare Commissioner, Bhubaneswar",
  "Office of The Welfare Commissioner, Chandigarh",
  "Office of The Welfare Commissioner, Dehradun",
  "Office of The Welfare Commissioner, Guwahati",
  "Office of The Welfare Commissioner, Hyderabad",
  "Office of the Welfare Commissioner, Jabalpur",
  "Office of The Welfare Commissioner, Kannur",
  "Office of the Welfare Commissioner, Koderma",
  "Office of the Welfare Commissioner, Kolkatta",
  "Office of The Welfare Commissioner, Nagpur",
  "Office of The Welfare Commissioner, Patna",
  "Office of The Welfare Commissioner, Tirunelveli",
  "V.V. Giri National Labour Institute",
  "CDGI Ferozabad",
  "CFTI Agra",
  "CFTI Chennai",
  "CIHT Jalandhar",
  "Coir Board",
  "CTR Ludhiana",
  "CTRTC Bhubneswar",
  "CTRTC KolKata",
  "Development Commissioner (Micro Small and Medium Enterprises)",
  "DEVELOPMENT INSTITUTE, RAIPUR",
  "ESTC Ramnagar",
  "FFDC Kannauj",
  "HTDDTC Nagaur",
  "IDEMI Mumbai",
  "IDTR Jamshedpur",
  "IGTR Aurangabad",
  "Indian Institute of Entrepreneurship",
  "Khadi & Village Industries Commission",
  "Mahatma Gandhi Institute for Rural Industrialisation (MGIRI)",
  "Ministry of Micro, Small and Medium Enterprises",
  "MSME Development Institute Agra",
  "MSME Development Institute, Bangalore",
  "MSME Development Institute Chennai",
  "MSME Development Institute karnal",
  "MSME Development Institute,Kolkata",
  "MSME Development Institute, Ludhiana",
  "MSME Development Institute, Margao, Goa",
  "MSME Development Institute Patna",
  "MSME DI Ahmedabad",
  "MSMEDI, Cuttack",
  "MSME DI Gangtok",
  "MSME DI Guwahati",
  "MSME DI, Haldwani",
  "MSME DI Hubli",
  "MSME DI Hyderabad",
  "MSME DI JAIPUR",
  "MSME DI KANPUR",
  "MSME DI Muzaffarpur",
  "MSME DI SOLAN",
  "MSMEDI Thrissur",
  "MSME DIVELOPMENT INSTITUTE INDORE",
  "MSME Testing Centre, Chennai",
  "MSME Testing Centre Kolkata",
  "M S M E TESTING CENTRE NEW DELHI",
  "MSMETI Ettumanoor",
  "MSMETI THIRUVALLA",
  "MSME tool room Ahmedabad",
  "MSME TOOL ROOM GUWAHATI",
  "MSME TOOL ROOM HYDERABAD CITD",
  "MSME Tool Room Indore",
  "National Institute for Entrepreneurship & Small Business Development (NIESBUD)",
  "National Institute of Micro Small and Medium Enterprises (NIMSME)",
  "PPDC Agra",
  "PPDC Meerut",
  "RTC-Mumbai",
  "SISI Agartala",
  "SISI Allahabad",
  "SISI-Goa",
  "SISI-Imphal",
  "SISI-Jammu",
  "SISI-Mumbai",
  "SISI-Nagpur",
  "SISI-New Delhi",
  "SISI-Ranchi",
  "The National Small Industries Corporation Ltd",
  "Geological Survey of India",
  "Hindustan Copper Ltd.",
  "Indian Bureau of Mines",
  "Jawaharlal Nehru Aluminium Research Development and Design Centre.",
  "Mineral Exploration Corporation Ltd.",
  "Ministry of Mines",
  "National Aluminium Company Ltd.",
  "National Institute of Miners Health",
  "National Institute of Rock Mechanics",
  "Central Waqf Council",
  "Dargah Khwaja Ajmer Saheb",
  "Maulana Azad Education Foundation",
  "Maulana Azad National Academy for Skills",
  "Ministry of Minority Affairs",
  "National Commissioner for Linguistic Minorities",
  "National Commission for Minorities",
  "National Minorities Development and Finance Corporation",
  "Indian Renewable Energy Development Authority Limited (IREDA)",
  "Ministry of New & Renewable Energy",
  "National Institute of Solar Energy (NISE)",
  "National Institute of Wind Energy(NIWE)",
  "Sardar Swaran Singh National Institute of Bio Energy (SSS-NIBE)",
  "Solar Energy Corporation of India (SECI)",
  "Ministry of Panchayati Raj",
  "Ministry of Parliamentary Affairs",
  "Balmer Lawrie & Co. Ltd.",
  "Balmer Lawrie Investments Limited",
  "Bharat Petroleum Corporation Limited (BPCL)",
  "Bharat PetroResources Ltd. & BPRJPDA",
  "Centre for High Technology",
  "Chennai Petroleum Corporation Limited (CPCL)",
  "Directorate General of Hydrocarbons",
  "Engineers India Limited (EIL)",
  "GAIL (India) Limited",
  "Hindustan Petroleum Corporation Limited (HPCL)",
  "Indian Institute of Petroleum & Energy (IIPE)",
  "Indian Oil Corporation Limited (IOCL)",
  "Indian Strategic Petroleum Reserves Limited",
  "Mangalore Refinery & Petrochemicals Limited (MRPL)",
  "Ministry of Petroleum & Natural Gas",
  "Numaligarh Refinery Limited (NRL)",
  "Numaligarh Refinery Ltd. (NRL)",
  "Oil India Limited (OIL)",
  "Oil Industry Development Board (OIDB)",
  "Oil Industry Safety Directorate (OISD)",
  "Oil & Natural Gas Corporation Limited (ONGC)",
  "ONGC Mangalore Petrochemicals Limited",
  "ONGC Videsh Limited (OVL)",
  "Petroleum and Natural Gas Regulatory Board (PNGRB)",
  "Petroleum Conservation & Research Association (PCRA)",
  "Petroleum Planning & Analysis Cell (PPAC)",
  "Rajiv Gandhi Institute of Petroleum Technology (RGIPT)",
  "Appellate Tribunal for Electricity",
  "Bhakra Beas Management Board",
  "Bureau of Energy Efficiency",
  "Central Electricity Authority",
  "Central Electricity Regulatory Commission",
  "Central Power Research Institute",
  "Damodar Valley Corporation",
  "Energy Efficiency Services Ltd. (EESL)",
  "Grid Controller of India Limited",
  "Ministry of Power",
  "National Hydroelectric Power Corporation (NHPC)",
  "National Power Training Institute",
  "National Thermal Power Corporation",
  "North Eastern Electric Power Corporation",
  "Power Finance Corporation Ltd.",
  "Power Grid Corporation of India Ltd.",
  "Power System Operation Corporation Limited",
  "Rural Electrification Corporation Ltd.",
  "Satluj Jal Vidyut Nigam Ltd.",
  "Tehri Hydro Development Corporation",
  "Ajmer Division- NWR",
  "Ajmer Work shop- NWR",
  "Bharat Wagon Engineer Company Ltd",
  "Bikaner Division- NWR",
  "Bikaner Work shop- NWR",
  "Braithwaite and Co Ltd",
  "Burn Standrad Co. Ltd. (Subs BBUNL)",
  "Central Oraganization Railway Electrification (CORE),Allahabad",
  "Central Organisation for Modernisation of Workshops",
  "CENTRAL RAILWAY",
  "Centre for Railway Information System (CRIS)",
  "Chittaranjan Locomotive Works, Chittaranjan",
  "Container Corporation of India Ltd.",
  "Dedicated Freight Corridor Corporation of India Limited",
  "Diesel Loco Modernisation works, Patiala",
  "Diesel Locomotive Works, (DLW), Varanasi",
  "DRM Office, Central Railway, Bhusaval",
  "DRM Office, Central Railway, Mumbai",
  "DRM Office, Central Railway, Nagpur",
  "DRM Office, Central Railway, Pune",
  "DRM Office, Central Railway, Solapur",
  "East Central Railway",
  "East Central Railway- Danapur Divison",
  "East Central Railway- DELF, Patna",
  "East Central Railway- Dhanbad Divison",
  "East Central Railway- GELF, Madhepura",
  "East Central Railway- Harnaut Workshop",
  "East Central Railway- Mughalsarai Division",
  "East Central Railway- Plant Depot, Mughalsarai",
  "East Central Railway- Samastipur Divison",
  "East Central Railway- Samastipur Workshop",
  "East Central Railway- Sonpur Divison",
  "East Coast Railway, Bhubaneshwar",
  "Eastern Railway",
  "Eastern Railway- Asansol Division",
  "Eastern Railway- Howrah Division",
  "Eastern Railway- Jamalpur Workshop",
  "Eastern Railway- Kanchrapara Workshop",
  "Eastern Railway- Lilulah Workshop",
  "Eastern Railway- Maldah Division",
  "Eastern Railway- Sealdah Division",
  "General Store Ajmer- NWR",
  "Indian Railway Catering & Tourism Corpn .Ltd.",
  "Indian Railway Finance Corporation Ltd.",
  "Indian Railway Institute Of Signal Engineering and Telecommunications (IRISET)",
  "Indian Railway Welfare Organisation",
  "Integral Coach Factory, Chennai",
  "IRCON International Limited",
  "Jaipur Division- NWR",
  "Jodhpur Division- NWR",
  "Jodhpur Work shop-NWR",
  "Kolkata Metro Rail Corporation Ltd.",
  "Konkan Railway",
  "Metro Railway Kolkata",
  "Ministry of Railways",
  "Modern Coach Factory, Raebareli",
  "Mumbai Railway Vikas Corporation Ltd.",
  "National Academy of Indian Railways",
  "National High Speed Rail Corporation Limited(NHSRCL)",
  "North-Central Railway",
  "North-Central Railway- Agra Division",
  "North-Central Railway- Allahabad Division",
  "North-Central Railway- Jhansi Division",
  "North-Central Railway- Jhansi Workshop",
  "North-Central Railway- RSK/Sithouli (Gwalior)",
  "North Eastern (N.E) Railway",
  "North Eastern Railway- Izzatnagar Division",
  "North Eastern Railway- Izzatnagar Workshop",
  "North Eastern Railway-Lucknow Division",
  "North Eastern Railway- Varanasi Division",
  "Northeast Frontier(N.F) Railway",
  "Northern Railway",
  "Northern Railway- Alambagh Workshop",
  "Northern Railway- Ambala Division",
  "Northern Railway- Amritsar Workshop",
  "Northern Railway- Charbagh Workshop",
  "Northern Railway- Construction Organisation",
  "Northern Railway- Delhi Division",
  "Northern Railway- Firozpur Division",
  "Northern Railway- Jagadhari Workshop",
  "Northern Railway- Lucknow Division",
  "Northern Railway- Moradabad Division",
  "Northern Railway- USBRL Project",
  "North Western Railway",
  "Rail Coach Factory, Kapurthala",
  "Rail Land Development Authority",
  "RailTel Corporation of India Ltd.",
  "Rail Vikas Nigam Ltd.",
  "Railway Board",
  "Railway Claims Tribunal",
  "Rail Wheel Factory, Yelahanka, Bangalore",
  "Rail Wheel Plant, Bela",
  "Research Designs & Standards Organisation",
  "RITES LIMITED",
  "RRB (RailwayRecruitment Board), Ahmedabad",
  "RRB (Railway Recruitment Board), Ajmer",
  "RRB (Railway Recruitment Board), Allahabad",
  "RRB (Railway Recruitment Board), Bangalore",
  "RRb (Railway Recruitment Board), Bhopal",
  "RRB (Railway Recruitment Board), Bhubaneswar",
  "RRB (Railway Recruitment Board), Bilaspur",
  "RRB (Railway Recruitment Board), Chandigarh",
  "RRB (Railway Recruitment Board), Chennai",
  "RRB (Railway Recruitment Board), Gorakhpur",
  "RRB (Railway Recruitment Board), Guwahati",
  "RRB (Railway Recruitment Board), Jammu",
  "RRB (Railway Recruitment Board), Kolkata",
  "RRB (Railway Recruitment Board), Malda",
  "RRB (Railway Recruitment Board), Mumbai",
  "RRB (Railway Recruitment Board), Muzaffarpur",
  "RRB (Railway Recruitment Board), Patna",
  "RRB (Railway Recruitment Board), Ranchi",
  "RRB (Railway Recruitment Board), Secunderabad",
  "RRB (Railway Recruitment Board), Silliguri",
  "RRB (Railway Recruitment Board), Trivandrum",
  "South Cental Railway- Nanded Division",
  "South-Central Railway",
  "South Central Railway- CRS Tirupati",
  "South Central Railway- Guntakal Division",
  "South Central Railway- Guntur Division",
  "South Central Railway- Hyderabad Division",
  "South Central Railway- LGDS Hyderabad",
  "South Central Railway- RYPS Rayanapadu",
  "South Central Railway- Secunderabad Division",
  "South Central Railway- Vijayawada Division",
  "South East Central Railway- Bilaspur Division",
  "South East Central Railway-HQ",
  "South East Central Railway- Nagpur Division",
  "South East Central Railway- Raipur Division",
  "South East Central Railway-Workshop Motibagh/NGP",
  "South East Central Railway- W.R.S. Raipur",
  "South-Eastern Railway",
  "Southern Railway",
  "Southern Railway- Carriage & Wagon Workshop, Perambur",
  "Southern Railway- Central Workshop Golden Rock",
  "Southern Railway- Chennai Division",
  "Southern Railway- Engineering Workshop, Arakkonam",
  "Southern Railway- Loco Workshop, Perambur",
  "Southern Railway- Madurai Division",
  "Southern Railway- Palakkad Division",
  "Southern Railway- Salem Division",
  "Southern Railway- Signal &Telecommunication Workshop",
  "Southern Railway- Thiruchirappalli Division",
  "Southern Railway- Trivandrum Division",
  "Southern Railway- Workshop Electrical Services, Perambur",
  "South Western Railway",
  "South Western Railway- Bengaluru Division",
  "South Western Railway- Carriage Repair Workshop, Hubballi",
  "South Western Railway- Construction Unit",
  "South Western Railway- Hubballi Division",
  "South Western Railway- Mysuru Division",
  "South Western Railway- Mysuru Workshop",
  "West-Central Railway",
  "West Central Railway- Bhopal Division",
  "West Central Railway- Coach Repair Workshop, Bhopal",
  "West Central Railway- Jabalpur Division",
  "West Central Railway- Kota Division",
  "West Central Railway- Kota Workshop",
  "Western Railway",
  "Western Railway- Ahmedabad Division",
  "Western Railway- Bhavnagar Division",
  "Western Railway- Mumbai Division",
  "Western Railway- Rajkot Division",
  "Western Railway- Ratlam Division",
  "Western Railway- Vadodara Division",
  "ZRTI Udaipur- NWR",
  "Indian Academy of Highway Engineers (IAHE)",
  "Indian Roads Congress",
  "Ministry of Road Transport & Highways",
  "National Highways Authority of India (NHAI)",
  "National Highways & Infrastructure Development Corporation Limited (NHIDCL)",
  "Administration, NIRDPR",
  "Department of Land Resources",
  "Ministry of Rural Development",
  "Andaman Lakshdweep Harbour Works",
  "Calcutta Dock Labour Board",
  "Central Inland Water Transport Co. Ltd.",
  "Chennai Port Trust",
  "Cochin Port Trust",
  "Cochin Shipyard Limited",
  "Directorate General of Lighthouses & Lightships",
  "Directorate General of Shipping DG(S)",
  "Dredging Corporation of India Limited, Visakhapatnam",
  "Hoogly Dock & Port Engineers Ltd.",
  "Indian Maritime University, Chennai",
  "Inland Waterways Authority of India, Noida",
  "Jawaharlal Nehru (Nhava Seheva) Port Trust",
  "Kamarajar Port Limited",
  "Kandla Port Trust",
  "Kolkata Port Trust",
  "Minor Ports Survey Organisation",
  "Ministry of Shipping",
  "Mormugao Port Trust",
  "Mumbai Port Trust",
  "New Mangalore Port Trust",
  "Paradip Port Trust",
  "Seamen Provident Fund Organisation, Mumbai",
  "Sethusamudram Corporation Ltd",
  "Shipping Corporation of India Limited",
  "Tariff Authority for Major Ports",
  "Visakhapatnam Port Trust",
  "V.O. Chidambarnar Port Trust",
  "Directorate General of Training (DGT)",
  "Directorate of Jan Shikshan Sansthan (DJSS)",
  "Ministry of Skill Development & Entrepreneurship",
  "National Council for Vocational Education and Training(NCVET)",
  "National Skill Development Agency (NSDA)",
  "National Skill Development Corporation (NSDC)",
  "Ali Yavar Jung, National Institute for the Hearing Handicapped",
  "Artificial Limbs Manufacturing Corporation of India",
  "Babu Jagjiwan Ram National Foundation",
  "Deendayal Upadhyay Institute for the Physically Handicapped (IPH)",
  "Department of Empowerment of Person with Disabilities (Divyangjan)",
  "Dr. Ambedkar Foundation",
  "Indian Sign Language Research & Training Centre",
  "Ministry of Social Justice & Empowerment",
  "National Backward Classes Finance & Development Corporation",
  "National Commission for Backward Classes",
  "National Commission for Safai Karamcharis",
  "National Commission for Scheduled Castes",
  "National Handicapped Finance and Development Corporation",
  "National Institute for Empowerment of Persons with Multiple Disabilities (NIEPMD)",
  "National Institute for Orthopaedically Handicapped",
  "National Institute for Social Defence",
  "National Institute for the Mentally Handicapped",
  "National Institute for the Visually Handicapped",
  "National Institute of Mental Health Rehabilitation, Sehore",
  "National Safai Karmacharis Finance and Development Corporation",
  "National Scheduled Castes Finance and Development Corporation",
  "National Trust for the Persons with Cerebral Palsy, Autism, Mental Retardation & Multiple Disability",
  "Office of the Chief Commissioner for Persons with Disabilities",
  "Rehabilitation Council of India",
  "Swami Vivekanand National Institute of Rehabilitation Training and Research",
  "Ministry of Statistics & Programme Implementation",
  "Biju Patnaik National Steel Institute",
  "Bird Group of Companies",
  "Ferro Scrap Nigam Limited",
  "Hindustan Steelworks Construction Ltd.(HSCL)",
  "Institute of Steel Developemnt Growth (INSDAG)",
  "Joint Plant Committee",
  "KIOCL Limited",
  "Maganese Ore (India) Ltd.",
  "MECON Limited",
  "Ministry of Steel",
  "MSTC Limited",
  "National Institute of Secondary Steel Technology(NISST)",
  "National Mineral Development Corporation Limited (NMDC)",
  "Rashtraiya Ispat Nigam Ltd.",
  "Steel Authority of India Ltd. (SAIL)",
  "British India corporation",
  "Central Cottage Industries Corporation of India Ltd.",
  "Central Silk Board",
  "Central Wool Development Board",
  "Cotton Corporation of India Ltd.",
  "Handicrafts and Handlooms Exports Corpn. of India",
  "Ministry of Textiles",
  "National Handloom Development Corporation Limited",
  "National Institute of Fashion Technology",
  "National Jute Board",
  "National Jute Manufactures Corporation Ltd",
  "National Textiles Corporation Ltd.",
  "Office of Development Commissioner(Handicrafts)",
  "Office of Development Commissioner(Handlooms)",
  "Office of Jute Commissioner",
  "Office of Textile Commissioner",
  "Sardar Vallabhbhai Patel Institute of Textile Management",
  "Textile Committee",
  "The Jute Croporation of India Limited",
  "IHM Bangaluru",
  "IHM Bhopal",
  "IHM Bhubaneswar",
  "IHM Chandigarh",
  "IHM Chennai",
  "IHM Gandhinagar",
  "IHM Goa",
  "IHM Gurdaspur",
  "IHM Guwahati",
  "IHM Gwalior",
  "IHM Hajipur",
  "IHM Hyderabad",
  "IHM Jaipur",
  "IHM Kolkata",
  "IHM Lucknow",
  "IHM Mumbai",
  "IHM PUSA",
  "IHM Shimla",
  "IHM Srinagar",
  "IHM Thiruvanathapuram",
  "IIITTM Gwalior",
  "Ministry of Tourism",
  "India Tourism Development Corporation (ITDC)",
  "National Council for Hotel Management & Catering Technology (NCHMCT)",
  "Ministry of Tribal Affairs",
  "National Commision for Scheduled Tribes",
  "Tribal Cooperative Marketing Development Federation of India Limited",
  "Bansagar Control Board",
  "Betwa River Board",
  "Brahmaputra Board",
  "Central Ground Water Board",
  "Central Soil & Materials Research Station",
  "Central Water and Power Research Station",
  "Central Water Commission",
  "Farakka Barrage Project",
  "Ganga Flood Control Commission",
  "Godavari River Management Board",
  "Krishna River Management Board",
  "Ministry of Water Resources, River Development & Ganga Rejuvenation",
  "Narmada Control Authority",
  "National Institute of Hydrology",
  "National Projects Construction Corporation Limited",
  "National Water Development Agency",
  "National Water Informatics center",
  "North Eastern of Regional Institute of Water & Land Management",
  "Polavaram Project Authority",
  "Sardar Sarovar Construction Advisory Committee",
  "Tungabhadra Board",
  "Upper Yamuna River Board",
  "WAPCOS Limited",
  "Central Adoption Resource Authority",
  "Central Social Welfare Board",
  "Ministry of Women & Child Development",
  "National Commission for Protection of Child Rights",
  "National Commission for Women (NCW)",
  "National Institute of Public Coperation and Child Development (NIPCCD)",
  "Rashtriya Mahila Kosh",
  "Lakshmibai National Institute of Physical Education",
  "Ministry of Youth Affairs & Sports",
  "National Service Scheme",
  "National Sports University",
  "Nehru Yuva Kendra Sangathan",
  "Rajiv Gandhi National Institute of Youth Development",
  "Sports Authority of India",
  "National Institution for Transforming India (NITI Aayog)",
  "Unique Identification Authority of India",
  "President Secretariat",
  "Prime Minister's Office",
  "Rajya Sabha Secretariat",
  "Chandigarh Right to Service Commission",
  "Market Committee",
  "UT Chandigarh- Administrative Wing (MCC)",
  "UT Chandigarh- Agricultural Census",
  "UT Chandigarh- Agriculture Department",
  "UT Chandigarh- Agriculture Marketing Board",
  "UT Chandigarh- Animal Husbandry & Fisheries",
  "UT Chandigarh- Ayurveda, Yoga and Naturopathy, Unani Siddha & Homeopathy (AYUSH)",
  "UT Chandigarh- Central Treasury",
  "UT Chandigarh- Chandigarh Child Women Development Corporation Limited",
  "UT Chandigarh- Chandigarh College of Architecture",
  "UT Chandigarh- Chandigarh Housing Board (CHB)",
  "UT Chandigarh- Chandigarh Industrial Tourism Development Corporation (CITCO)",
  "UT Chandigarh- Chandigarh Pollution Control Committee (CPCC)",
  "UT Chandigarh- Chandigarh S.C.B.C. and Development Corporation Limited",
  "UT Chandigarh- Chandigarh State Consumer Disputes Redressal Commission",
  "UT Chandigarh- Chandigarh Transport Undertaking (CTU) & Transport",
  "UT Chandigarh- Chandigrh College of Engineering Technology (Degree Wing)",
  "UT Chandigarh- Cooperative Societies",
  "UT Chandigarh- Cultural Affairs",
  "UT Chandigarh- Deputy Commissioner & District Magistrate",
  "UT Chandigarh- Election",
  "UT Chandigarh- Engineering",
  "UT Chandigarh- Engineering (MCC)",
  "UT Chandigarh- Environment",
  "UT Chandigarh- Estate Office",
  "UT Chandigarh- Excise & Taxation",
  "UT Chandigarh- Fire & Emergency Services (MCC)",
  "UT Chandigarh- Food & Supplies,Consumer Affairs & Legal Metrology",
  "UT Chandigarh- Forest & Wildlife",
  "UT Chandigarh- Govt. College of Arts",
  "UT Chandigarh- Govt. Institute for Mentally Retarded Children (GRIID)",
  "UT Chandigarh- Govt. Medical College & Hospital (GMCH 32)",
  "UT Chandigarh- Govt. Museum & Art Gallery",
  "UT Chandigarh- Health",
  "UT Chandigarh- Health & Sanitation MOH (MCC)",
  "UT Chandigarh- Higher Education",
  "UT Chandigarh- Home Guards",
  "UT Chandigarh- Hospitality",
  "UT Chandigarh- House Allotment Committee",
  "UT Chandigarh- ICDS Social Welfare",
  "UT Chandigarh- Industries",
  "UT Chandigarh- Information Technology",
  "UT Chandigarh- Labour",
  "UT Chandigarh- Law & Prosecution",
  "UT Chandigarh- Local Audit",
  "UT Chandigarh- Planning & Evaluation Organisation",
  "UT Chandigarh- Planning Evaluation Organization",
  "UT Chandigarh- Police",
  "UT Chandigarh- Printing & Stationery",
  "UT Chandigarh- Prisons",
  "UT Chandigarh- Public Relations",
  "UT Chandigarh- Punjab Engineering College (PEC)",
  "UT Chandigarh- Red Cross Society",
  "UT Chandigarh- Regional Employment Exchange",
  "UT Chandigarh- Registring Licensing Authority",
  "UT Chandigarh- Rent Controller Office",
  "UT Chandigarh- School Education",
  "UT Chandigarh- Science & Technology & Renewable Energy",
  "UT Chandigarh- Secretariat & Home & Finance",
  "UT Chandigarh- Social Welfare & Women & Child Development",
  "UT Chandigarh- Sports",
  "UT Chandigarh- State Legal Services Authority",
  "UT Chandigarh- State Transport Authority (STA)",
  "UT Chandigarh- Statistical Cell",
  "UT Chandigarh- Sub Divisional Magistrate- Central (SDM-C)",
  "UT Chandigarh- Sub Divisional Magistrate- East (SDM-E)",
  "UT Chandigarh- Sub Divisional Magistrate - South (SDM-S)",
  "UT Chandigarh- Technical Education",
  "UT Chandigarh- Tourism",
  "UT Chandigarh- Urban Planning (Architect & Town Planning)",
  "UT Chandigarh- Vigilance",
  "UT Chandigarh- Zila Parishad",
  "UT Chandigarh- Zila Sainik Welfare Board",
  "UT Puducherry- Adi Dravidar Welfare & Scheduled Tribes Welfare Department",
  "UT Puducherry- Chief Secretariat",
  "UT Puducherry- Collectorate, Karaikal",
  "UT Puducherry- Commercial Taxes Department",
  "UT Puducherry- Co-operative Department",
  "UT Puducherry- Department of Agriculture & Farmers Welfare",
  "UT Puducherry- Department of Animal Husbandry & Animal Welfare",
  "UT Puducherry- Department of Art & Culture",
  "UT Puducherry- Department of Civil Supplies & Consumer Affairs",
  "UT Puducherry- Department of Information & Publicity",
  "UT Puducherry- Department of Revenue and Disaster Management",
  "UT Puducherry- Department of SAINIK Welfare",
  "UT Puducherry- Department of Science, Technology & Environment",
  "UT Puducherry- Department of Women & Child Development",
  "UT Puducherry- Dept. of Fisheries and Fishermen Welfare",
  "UT Puducherry- Directorate of Accounts & Treasuries",
  "UT Puducherry- Directorate of Economics and Statistics",
  "UT Puducherry- Directorate of Forest & Wildlife",
  "UT Puducherry- Directorate of Health & Family Welfare Services",
  "UT Puducherry- Directorate of Higher & Tech. Education",
  "UT Puducherry- Directorate of Industries & Commerce",
  "UT Puducherry- Directorate of Information Technology",
  "UT Puducherry-Directorate of Rural Development",
  "UT Puducherry- Directorate of School Education",
  "UT Puducherry- Directorate of Social Welfare",
  "UT Puducherry- Directorate of Stationery and Printing",
  "UT Puducherry- Directorate of Tourism",
  "UT Puducherry- District Industries Centre",
  "UT Puducherry- Elections Department",
  "UT Puducherry- Electricity Department",
  "UT Puducherry- Fire Service Department",
  "UT Puducherry- Labour Department",
  "UT Puducherry- Law Department",
  "UT Puducherry- Legislative Assembly Secretariat",
  "UT Puducherry- Local Administration Department",
  "UT Puducherry- Lt. Governor’s Secretariat",
  "UT Puducherry- NCC Group Headquarters",
  "UT Puducherry- Office of the Council of Ministers",
  "UT Puducherry- Planning & Research Department",
  "UT Puducherry- Police Department",
  "UT Puducherry- Public Works Department",
  "UT Puducherry- Regional Administrator, Yanam",
  "UT Puducherry- State Election Commission",
  "UT Puducherry- The Regional Administrator, Mahe",
  "UT Puducherry- Town & Country Planning Department",
  "UT Puducherry- Transport Department",
  "Vice-President Secretariat"
];

// Gender List for dropdowns
export const genderList = [
  "Male",
  "Female",
  "Other"
];

// Subscriber's Sector options
export const sectorList = [
  "Government Sector",
  "All India citizens/corporate",
  "NPS Lite / GDS"
];

// Marital Status options
export const maritalStatusList = [
  "Single",
  "Married",
  "Divorced",
  "Widowed"
];

export const bankNameList = [
  'State Bank of India',
  'Bank of Baroda',
  'Bank of India',
  'Indian Bank',
  'Punjab National Bank',
  'HDFC Bank Ltd',
  'ICICI Bank Ltd.',
  'Axis Bank Ltd.',
  'Kotak Mahindra Bank Ltd',
  'IDBI Bank Ltd.',
  'Canara Bank',
  'Central Bank of India',
  'Union Bank of India',
  'Au Small Finance Bank Limited',
  'Bandhan Bank Ltd.',
  'Bank of Maharashtra',
  'Capital Small Finance Bank Limited',
  'City Union Bank Ltd.',
  'CSB Bank Ltd.',
  'DCB Bank Ltd.',
  'Dhanlaxmi Bank Ltd.',
  'Equitas Small Finance Bank Limited',
  'ESAF Small Finance Bank Limited',
  'Federal Bank Ltd.',
  'Fincare Small Finance Bank Limited',
  'IDFC First Bank Ltd.',
  'Indian Overseas Bank',
  'Induslnd Bank Ltd',
  'Jammu & Kashmir Bank Ltd.',
  'Jana Small Finance Bank Limited',
  'Karnataka Bank Ltd.',
  'Karur Vysya Bank Ltd.',
  'Nainital Bank Ltd.',
  'North East Small Finance Bank Limited',
  'Punjab & Sind Bank',
  'RBL Bank Ltd.',
  'Shivalik Small Finance Bank Limited',
  'South Indian Bank Ltd.',
  'Suryoday Small Finance Bank Limited',
  'Tamilnad Mercantile Bank Ltd.',
  'UCO Bank',
  'Ujjivan Small Finance Bank Limited',
  'Unity Small Finance Bank Limited',
  'Utkarsh Small Finance Bank Limited',
  'YES Bank Ltd.'
];


export const annuityFrequencyList = [
  "Monthly",
  /* "Quarterly",
  "Half Yearly",
  "Yearly", */
];


export const annuitySchemeList = [
  {
    "schemeName": "Join life Annuity (ROP)",
    "schemeDescription": "- You get a monthly pension for your whole life.\n- After you die, your husband or wife gets the same pension every month for their life.\n- When both of you are no longer alive, your nominee (the person you choose) will get back the full amount you paid to buy this plan.\n\n**Example:**\n- You buy this plan with ₹10 lakh.\n- First, you get the pension every month.\n- After you die, your spouse gets the same pension every month.\n- When both of you are gone, your nominee gets ₹10 lakh back."
  },
  {
    "schemeName": "NPS-Family Income (ROP)",
    "schemeDescription": "- First, the pension is paid to the subscriber for life.\n- Then, after the subscriber’s death, the spouse will receive the pension for their lifetime.\n- Next, if the spouse has also passed away, but the subscriber’s mother is alive, she will start receiving the pension.\n- If the mother passes away too, then the subscriber’s father will get the pension.\n- Finally, after all these people (subscriber, spouse, mother, father) have passed away, the total invested amount (purchase price) will be given to the nominee (the children or whoever is named as nominee)."
  },
  {
    "schemeName": "Annuity for life (ROP)",
    "schemeDescription": "- As long as you are alive, you will get a monthly pension.\n- After your death, the full amount you used to buy the pension plan will be returned to your nominee or family.\n\n**Example:**\n- Suppose you bought an \"Annuity for Life (ROP)\" plan from NPS with ₹10 lakh.\n- You will receive a fixed pension every month or year.\n- After your death, your nominee will get the full ₹10 lakh back."
  }
]
